/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import { IBrokerage, IBrokerageInfo, IGmrObject, INewBroker } from "../interfaces/GetMyRate";
import "../../styles/gmr.scss";
import "../../styles/steps.scss";
import { calculateMockGMR, exportMockGMRQuote, exportMockGMRQuotes, getMockGMRInfolist, getMockGMRMetadata, getMockGmrScenarios, getMockGMRSummary, getMockGmrEmployeesMetadata, sendMockEmailToBroker, getMockGmrBorrowers, getMockBrokerEmailExists, createMockNewBroker, getMockSimilarBrokerageNameList, getMockAssociatedBorrowers, getMockBorrowerEntity, getMockAllBorrowers, getMockAllBrokers, submitMockAnonymousGmr } from "../../api/mock/MockBrokerApi";
import { calculateGMR, exportGMRQuote, exportGMRQuotes, getGMRInfoList, getGMRMetadata, getGmrScenarios, getGMRSummary, recalculateGMR, getInternalContacts, sendEmailToBroker, getGmrBorrowers, getBrokerEmailExists, createNewBroker, getSimilarBrokerageNameList, getAssociatedBorrowers, getBorrowerEntity, getAllBorrowers, getAllBrokers, submitAnonymousGmr } from "../../api/BrokerApi";
import { Button, Card, Form, Grid, Header, Icon, Loader, Table } from "semantic-ui-react";
import { handleErrorResponse, createFile, getDropdownOptions, guid, handleFormChange, handleInputType, isValidPermission, removeFromArrayByValues, setBackgroundColor, validateNestedObj, validateObj, deepCopy, convertToDollar, convertToDateString, convertToMinFraction, roundNumber, handleAddressValue, validateEmails, combineAddresses } from "../../Helpers";
import BCSteps from "../ui/BCSteps";
import BCFormInput from "../ui/BCFormInput";
import BCValidationMessage from "../ui/BCValidationMessage";
import { css } from "@emotion/css";
import { GlobalConstants, Personas } from "../constants/GlobalConstants";
import { BrokerConstants, ConfigDefaults } from "../../components/constants/BrokerConstants";
import BCModal from "../ui/BCModal";
import BPPricingScenario from "./BPPricingScenario";
import BCMessage from "../ui/BCMessage";
import { getIsWhiteLabeled, whoAmI } from "../../helpers/PermissionHelper";
import { BPAssociatedBrokerQuestion, BPBorrowerEntityAdditionalInformation, BPBorrowerEntitySelection, BPBrokerEmailQuestion, BPBrokerFeeRateQuestion, BPSelectLoanOfficerQuestion } from "./BPApplicationQuestions";
import BPNewBrokerModals from "./BPNewBrokerModals";
import { FeatureFlags } from "../constants/LocalServerConstants";
import { handleAssociatedBorrowers, handleAssociatedOrganizationContactId, handlePurchaseOrRefinanceOptions } from "../../helpers/MasterPortalHelper";

const BPGetMyRate = ({
  isGreaterThanMobile,
  isGreaterThanTablet,
  isSidebar,
  isMessage,
  setIsMessage,
  errorResponse,
  setErrorResponse,
  proxyUser,
  permissions,
  gmrId,
  brokerColor,
  setGmrEditData,
  copiedGmrId,
  isPricingStartScenarios,
  setIsPricingStartScenarios,
  user
}) => {
  const unfocusRef = useRef<HTMLElement>(null);
  const gmrRef = useRef<HTMLElement>(null);
  const exportRef = useRef<HTMLElement>(null);
  const originalScenarioRef = useRef<HTMLElement>(null);
  const scenario1Ref = useRef<HTMLElement>(null);
  const scenario2Ref = useRef<HTMLElement>(null);
  const [isFirstLoad, setIsFirstLoad] = useState(true as boolean);
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [isModalLoading, setIsModalLoading] = useState(true as boolean);
  const [isModalMessage, setIsModalMessage] = useState(false as boolean);
  const [gmrMetadata, setGmrMetadata] = useState({} as any);
  const [associatedBorrowers, setAssociatedBorrowers] = useState([] as any[]);
  const [gmrCalculationObject, setGmrCalculationObject] = useState({} as any);
  const [invalidProps, setInvalidProps] = useState([] as string[]);
  const [warningIds, setWarningIds] = useState([] as string[]);
  const [gmrObject, setGmrObject] = useState({
    loanOfficerOrganizationContactId: (proxyUser.id
      ? proxyUser.preferredLoanOfficerOrganizationContactId
      : user.preferredLoanOfficerOrganizationContactId) || undefined
  } as IGmrObject);
  const [newBorrowerEntity, setNewBorrowerEntity] = useState({} as any);
  const [currentProgress, setCurrentProgress] = useState(0 as number);
  const [furthestStepIndex, setFurthestStepIndex] = useState(0 as number);
  const [excludedStepIds, setExcludedStepIds] = useState([] as string[]);
  const OverviewLoanProgramStepId = "b9569362-d3e4-4d47-a233-8151b309a009";
  const [currentStepId, setCurrentStepId] = useState(OverviewLoanProgramStepId as string);
  const [exportURL, setExportURL] = useState(undefined as any);
  const [originalScenarioURL, setOriginalScenarioURL] = useState(undefined as any);
  const [scenario1URL, setScenario1URL] = useState(undefined as any);
  const [scenario2URL, setScenario2URL] = useState(undefined as any);
  const [exportLoading, setExportLoading] = useState(false as any);
  const [scenarioModal, setScenarioModal] = useState(FeatureFlags.IS_BC_PRICING ? true : false as boolean);
  const [scenarioModalObj, setScenarioModalObj] = useState({} as any);
  const [gmrScenarios, setGmrScenarios] = useState([] as any[]);
  const [previousModal, setPreviousModal] = useState(false as any);
  const [isScenarioExportModal, setIsScenarioExportModal] = useState(false as any);
  const [isScenarioSentToBrokerModal, setIsScenarioSentToBrokerModal] = useState(false as boolean);
  const [startApplicationModal, setStartApplicationModal] = useState(false as any);
  const [scenarioMessage, setScenarioMessage] = useState("" as string);
  const [sendToBroker, setSendToBroker] = useState(BrokerConstants.SendToBrokerModalStates.SendToBroker as string);
  const [isRecalculateValid, setIsRecalculateValid] = useState(false as any);
  const [brokerSearch, setBrokerSearch] = useState("" as string);
  const [brokerSearchDropdown, setBrokerSearchDropdown] = useState([] as any);
  const [selectedBrokerEmail, setSelectedBrokerEmail] = useState("" as string);
  const [isBrokerSearchFocus, setIsBrokerSearchFocus] = useState(false as boolean);
  const [newBroker, setNewBroker] = useState({} as INewBroker);
  const [isBrokerModalOpen, setIsBrokerModalOpen] = useState(false as boolean);
  const [isBrokerageNameModalOpen, setIsBrokerageNameModalOpen] = useState(false as boolean);
  const [isBrokerageInfoModalOpen, setIsBrokerageInfoModalOpen] = useState(false as boolean);
  const [isNewBrokerCreated, setIsNewBrokerCreated] = useState(false as boolean);
  const [similarBrokerageList, setSimilarBrokerageList] = useState([] as IBrokerage[]);
  const [newBrokerageId, setNewBrokerageId] = useState("" as string);
  const [newBrokerageName, setNewBrokerageName] = useState("" as string);
  const [isNewBrokerage, setIsNewBrokerage] = useState(false as boolean);
  const [brokerageInfo, setBrokerageInfo] = useState({} as IBrokerageInfo | any);
  const [defaultLoanOfficer, setDefaultLoanOfficer] = useState("" as string);
  const [isBrokerInvited, setIsBrokerInvited] = useState(false as boolean);
  const [internalEmployees, setInternalEmployees] = useState([] as any);
  const [recipientSearchInput, setRecipientSearchInput] = useState("" as string);
  const [recipientsDropdown, setRecipientsDropdown] = useState([] as any);
  const [selectedRecipients, setSelectedRecipients] = useState([] as any);
  const [isAddingRecipient, setIsAddingRecipient] = useState(false as boolean);
  const [emailBrokerObj, setEmailBrokerObj] = useState({} as any);
  const [isSendBrokerEmailLoading, setIsSendBrokerEmailLoading] = useState(false as boolean);
  const defaultScenarioMessage = "Unfortunately, the system glitched and we weren't able to save your scenario, please refresh the page and try again. We do apologize for the inconvenience, if this happens again, email your Loan Officer or wholesale@builders-capital.com.";
  const successMessage = `Email to ${gmrObject.brokerInfo && gmrObject.brokerInfo.firstName} has been sent`;
  const [isSubmitAnonymousModal, setIsSubmitAnonymousModal] = useState(false as any);
  const borrowerEntityDisclaimer1 = "This pricing tool is to be used for commercial business purposes only and the subject property will be sold or retained for business and/or investment purposes uponcompletion of the project.";
  const borrowerEntityDisclaimer2 = "Builders Capital does not provide loans for personal residences.";
  const borrowerEntityDisclaimer3 = "This proposal/pricing estimate is not to be construed as a commitment to lend money. Builders Capital and its affiliates will conduct customary due diligence with respect to Borrower, any proposed guarantors, and the property proposed to secure the loan. Borrower hereby authorizes such investigations, which may include but are not limited to credit reports on Borrower and any proposed guarantors, Borrower’s principals and affiliated entities, and an appraisal of the property proposed to secure the loan. This proposal does not contain all of the specific terms and conditions that may be included in the final loan documents if a loan is approved, and does not include all costs associated with the loan, including but not limited to inspection fees, draw fees, wire fees, late fees, and other fees. The final terms of the any loan, conditions to closing, timing of transaction closing, and actual funding shall be at the sole discretion of Builders Capital and its affiliates. For construction loans, budget overages or upgrades will be the responsibility of the Borrower. If a loan contains an interest reserve account, that account will be used to make required monthly payments on the loan until the reserve account is depleted, at which time the Borrower is required to make up any deficiency and payments as required by the loan agreement. All third party expenses incurred by Builders Capital after the acceptance of this pricing estimate by the Borrower are the responsibility of Borrower, whether or not Builders Capital agrees to make the loan. Acceptance of this pricing does not commit you to this loan.";
  const borrowerEntityDisclaimer4 = "Does not include other customary loan fees, such as Title, Appraisal, Processing or Credit Report.";
  const borrowerEntityDisclaimer5 = "No further changes can be made once you click Submit";
  const InterestReserveRadios = [
    {
      name: "Make monthly interest payments",
      value: false
    },
    {
      name: "Interest Reserve - roll interest payments into loan",
      value: true
    }
  ];
  const YesNoRadios = [
    {
      name: "Yes",
      value: true
    },
    {
      name: "No",
      value: false
    }
  ];
  const GmrWarnings = {
    Reinput: {
      id: "9e3ada24-ccbd-496c-9ca8-59cef4fd525f",
      message: "Due to changing this value, you may need to re-input your information in future steps."
    },
    OriginationFee: {
      id: "3a382d43-f78e-438c-a0ef-73e97f2ab17f",
      message: "Our policy is to only roll up to 2% into the origination fee. Any fee above that will show as an external broker fee."
    }
  };
  const ScenarioExportNames = {
    original: "original",
    scenario1: "scenario1",
    scenario2: "scenario2",
    scenario3: "scenario3"
  };

  let minMandatoryBrokerFee = ConfigDefaults.MIN_MANDATORY_BROKER_FEE;
  if (gmrMetadata && gmrMetadata.configs) {
    minMandatoryBrokerFee = gmrMetadata.configs.minMandatoryBrokerFee;
  }

  const pricingId = gmrId ? gmrId : guid();
  const isAnonymous = gmrId ? false : true;
  const persona = whoAmI(user, proxyUser);
  const isAdminBrmOrLo = [
    Personas.SYSTEM_ADMIN,
    Personas.SALES_ADMIN,
    Personas.BROKER_ADMIN,
    Personas.LOAN_OFFICER,
    Personas.BRM,
    Personas.NWL_GUARANTOR
  ].indexOf(persona) > -1; 

  const isAllBorrowersPersona = [
    Personas.SYSTEM_ADMIN,
    Personas.SALES_ADMIN,
    Personas.LOAN_OFFICER,
    Personas.BRM
  ].indexOf(persona) > -1; 

  const isStartApplicationPersona = [
    Personas.SALES_ADMIN,
    Personas.BROKER_ADMIN,
    Personas.LOAN_OFFICER,
    Personas.BRM,
    Personas.BROKER,
    Personas.WL_GUARANTOR,
    Personas.NWL_GUARANTOR
  ].indexOf(persona) > -1;

  const isAdminPersona = [
    Personas.SYSTEM_ADMIN,
    Personas.SALES_ADMIN,
    Personas.BROKER_ADMIN
  ].indexOf(persona) > -1;

  const brokerButtonOverrideCSS = css`
    background-color: ${brokerColor ? brokerColor : "black"} !important;
    color:#ffffff !important;
    font-family: $fontFamily !important;
    margin-top: 10px;
    width: 25%;
  `;

  const handleSelectBrokerage = (value, field) => {
    handleFormChange(value, field, brokerageInfo, setBrokerageInfo, GlobalConstants.InputTypes.STRING, handleCustomFormChange);
    const selectedBrokerage = similarBrokerageList.find(x => x.id === value);
    const brokerageKey = (name: keyof IBrokerage) : string => name;
    if (selectedBrokerage) {
      Object.entries(selectedBrokerage).forEach(([key, value]) => {
        if (key === brokerageKey("name")) {
          brokerageInfo.organizationName = value;
        } 
        else if (key === brokerageKey("id")) {
          brokerageInfo.organizationId = value;
        }
        else {
          brokerageInfo[key] = value;
        }
      });

      setBrokerageInfo({...brokerageInfo});
      setIsNewBrokerage(false);
    }
    else {
      setBrokerageInfo({ organizationName: newBrokerageName, organizationId: newBrokerageId });
      setIsNewBrokerage(true);
    }
  };

  const handleCustomFormChange = (field, value, formObj) => {
    if (field === OverviewQuestions.LoanProgram.field && [GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.DEVELOPMENT].indexOf(formObj[field]) > -1
      && [GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.DEVELOPMENT].indexOf(value) === -1) {
      const addWarningIds = warningIds.concat([GmrWarnings.Reinput.id]);
      setWarningIds([]);
      const asIsValueIndex = ApplicationSteps.findIndex(x => x.id === BudgetSteps.AsIsValue.id);
      if (furthestStepIndex > asIsValueIndex) {
        setFurthestStepIndex(asIsValueIndex);
      }

      setTimeout(() => {
        setWarningIds([...addWarningIds]);
      }, 50);
    }
    else if (field === ProjectQuestions.BuildTime.field && value > formObj[field] && gmrObject[ProjectQuestions.MonthOfFirstDraw.field]) {
      gmrObject[ProjectQuestions.MonthOfFirstDraw.field].forEach(gmrUnitDrawMonth => {
        if (gmrUnitDrawMonth.monthOfFirstDraw && gmrUnitDrawMonth.monthOfFirstDraw > handleCalculateMaxFirstDraw(value)) {
          gmrUnitDrawMonth.monthOfFirstDraw = handleCalculateMaxFirstDraw(value);
        }
      });
    }
    else if (field === "wlbrokerFeeRate" && (Number(value) + minMandatoryBrokerFee > 2) && !warningIds.includes(GmrWarnings.OriginationFee.id)) {
      const addWarningIds = warningIds.concat([GmrWarnings.OriginationFee.id]);
      setWarningIds([]);
      setTimeout(() => {
        setWarningIds([...addWarningIds]);
      }, 50);
    }
  };

  const handleCalculateMaxBuildTime = () => {
    if ([GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.DEVELOPMENT, GlobalConstants.LoanProgramIds.FIX_AND_FLIP].indexOf(gmrObject[OverviewQuestions.LoanProgram.field]) > -1) {
      return 12;
    }
    else if ([GlobalConstants.LoanProgramIds.ALL_IN_ONE].indexOf(gmrObject[OverviewQuestions.LoanProgram.field]) > -1) {
      return 24;
    }
    else {
      return 18;
    }
  };

  const handleCalculateValidBuildTimes = () => {
    let maxBuildTime = handleCalculateMaxBuildTime();
    if (maxBuildTime >= 18) {
      maxBuildTime = 18;
    }

    return Array.from(Array(maxBuildTime).keys(), x => x + 1) as number[];
  };

  const handleCalculateMaxFirstDraw = (totalBuildTimeInMonths) => {
    if (totalBuildTimeInMonths) {
      const maxBuildTime = handleCalculateMaxBuildTime();
      return maxBuildTime - totalBuildTimeInMonths + 1;
    }

    return 12;
  };

  const handleMonthOfFirstDrawFormChange = (value, index) => {
    if (!gmrObject[ProjectQuestions.MonthOfFirstDraw.field]) {
      gmrObject[ProjectQuestions.MonthOfFirstDraw.field] = [{}];
    }

    gmrObject[ProjectQuestions.MonthOfFirstDraw.field][index].unitNo = index;
    if (!isNaN(parseInt(value))) {
      if (value > handleCalculateMaxFirstDraw(gmrObject[ProjectQuestions.BuildTime.field])) {
        value = handleCalculateMaxFirstDraw(gmrObject[ProjectQuestions.BuildTime.field]);
      }

      gmrObject[ProjectQuestions.MonthOfFirstDraw.field][index].monthOfFirstDraw = parseInt(value);
    }
    else if (value === "") {
      gmrObject[ProjectQuestions.MonthOfFirstDraw.field][index].monthOfFirstDraw = undefined;
    }

    setGmrObject({ ...gmrObject });
  };

  const handleCalculateRequestedLoanTerm = () => {
    const validLoanTerms = Array.from(Array(12).keys(), x => x + 1);
    if (gmrObject[OverviewQuestions.LoanProgram.field] !== GlobalConstants.LoanProgramIds.BRIDGE && gmrObject[ProjectQuestions.BuildTime.field] && gmrObject[ProjectQuestions.MonthOfFirstDraw.field] && gmrObject[ProjectQuestions.MonthOfFirstDraw.field].length > 0 &&
      gmrObject[ProjectQuestions.MonthOfFirstDraw.field][0] && gmrObject[ProjectQuestions.MonthOfFirstDraw.field][0].monthOfFirstDraw) {
      const unitDrawMonths = Array.from(gmrObject[ProjectQuestions.MonthOfFirstDraw.field] as any[], y => y.monthOfFirstDraw);
      const maxUnitDrawMonth = Math.max(...unitDrawMonths);
      const minLoanTermDiff = handleCalculateMaxBuildTime() - gmrObject[ProjectQuestions.BuildTime.field] - maxUnitDrawMonth + 2;
      return Array.from(Array(minLoanTermDiff > 0 ? minLoanTermDiff : 1).keys(), x => x + gmrObject[ProjectQuestions.BuildTime.field] + maxUnitDrawMonth - 1);
    }

    return validLoanTerms;
  };

  const handleCostsPaidToDateFormChange = (value, index, field, type = "string") => {
    if (field === "description") {
      gmrObject[FinancingQuestions.CostsPaid.field][index][field] = handleInputType(type, value, undefined, undefined, 50);
    }
    else {
      gmrObject[FinancingQuestions.CostsPaid.field][index][field] = handleInputType(type, value);
    }

    setGmrObject({ ...gmrObject });
  };

  const handleAddCostsPaid = () => {
    gmrObject[FinancingQuestions.CostsPaid.field].push({ gmrId: gmrObject.id });
    setGmrObject({ ...gmrObject });
  };

  const handleRemoveCostsPaid = (index = 0) => {
    gmrObject[FinancingQuestions.CostsPaid.field].splice(index, 1);
    setGmrObject({ ...gmrObject });
  };

  const handleAssociatedBrokerChange = (value, field) => {
    if (!value) {
      setBrokerSearch("");
      gmrObject.brokerOrganizationContactId = null;
      delete gmrObject.brokerFeeRate;
      delete gmrObject.wlbrokerFeeRate;
    }

    user[field] = value;
    gmrObject[field] = value;
    setGmrObject({...gmrObject});
  };

  const handleAddBroker = () => {
    if (brokerSearch !== "") {
      handleNewBrokerModal();
    }
  };

  const handleBrokerSearchChange = async (value, field, charLimit = undefined as number | undefined) => {
    if (value && selectedBrokerEmail && value !== selectedBrokerEmail) {
      setSelectedBrokerEmail("");
      delete gmrObject.brokerOrganizationContactId;
      setGmrObject({...gmrObject});
    }

    handleFormChange(value, field, gmrObject, setGmrObject);
    const brokerSearchValue = handleInputType("string", value, undefined, undefined, charLimit);
    setInvalidProps([]);
    setBrokerSearch(brokerSearchValue);
    if (brokerSearchValue !== "" && gmrMetadata.associatedBrokers && gmrMetadata.associatedBrokers.length > 0) {
      const filteredBrokers = gmrMetadata.associatedBrokers.filter(x => ((x.firstName && ((x.firstName).toLowerCase().includes(brokerSearchValue.toLowerCase()))) || 
        (x.lastName && (x.lastName).toLowerCase().includes(brokerSearchValue.toLowerCase())) ||
        (x.email && (x.email).toLowerCase().includes(brokerSearchValue.toLowerCase()))));
        setBrokerSearchDropdown(filteredBrokers);
    }
    else if (brokerSearchValue === "" && gmrMetadata.associatedBrokers && gmrMetadata.associatedBrokers.length > 0) {
      setBrokerSearchDropdown(gmrMetadata.associatedBrokers);
    }
    else {
      setBrokerSearchDropdown([]);
    }
  };
  
  const handleDoubleFilterBrokerSuggestions = () => {
    const results = [] as any[];
    let resultLimit = 6;
    let associatedBrokers = gmrMetadata.associatedBrokers;
    if (brokerSearch && brokerSearch !== "") {
      associatedBrokers = brokerSearchDropdown;
    }

    if (associatedBrokers && associatedBrokers.length > 0) {
      associatedBrokers.forEach(broker => {
        if (resultLimit > 0 && broker.email !== brokerSearch) {
          const brokerObj = {
            id: broker.id,
            email: broker.email,
            firstName: broker.firstName,
            lastName: broker.lastName,
            status: broker.status
          };

          results.push({
            key: broker.id,
            title: `${broker.firstName} ${broker.lastName}`,
            description: broker.email,
            value: brokerObj,
            firstName: broker.firstName,
            lastName: broker.lastName,
            status: broker.status
          });

          resultLimit--;
        }
      });
    }

    return results;
  };

  const handleBrokerSelect = async (result) => {
    if (result && result !== "") {
      setInvalidProps([]);
      if (result.value && result.value.id && result.value.email) {
        setSelectedBrokerEmail(result.value.email);
        setGmrObject({...gmrObject, brokerOrganizationContactId: result.value.id, brokerSearchEmail: result.value.email });
      }

      setBrokerSearch(result.value.email);
      setIsBrokerSearchFocus(false);
    }
  };

  const handleBrokerSearchKeyDown = async (e) => {
    if (FeatureFlags.IS_BETA) {
      if (e.keyCode === 13 && currentStepId === BackgroundSteps.BrokerFeeRate.id && isBrokerSearchFocus) {
        await handleNewBrokerModal();
      }
      else if (e.keyCode === 27) {
        handleBrokerSearchClear();
      }
    }
  };

  const handleNewBrokerModal = async () => {
    const notValidEmails = validateEmails(gmrObject, ["brokerSearchEmail"]);
    if (notValidEmails.length === 0) {
      setInvalidProps([]);
      setIsLoading(true);
      const existedBrokerEmail = await handleGetBrokerEmailExistsAsync(brokerSearch);
      if (existedBrokerEmail) {
        setSelectedBrokerEmail(existedBrokerEmail);
        setIsBrokerSearchFocus(false);
      }
      else {
        newBroker.brokerEmail = brokerSearch;
        if (!newBroker.id) {
          newBroker.id = guid();
        }

        setNewBroker({...newBroker});
        setIsBrokerModalOpen(true);
      }

      setIsLoading(false);
    }
    else {
      invalidProps.push("custom-broker-invalid-email");
      setInvalidProps([...invalidProps]);
    }
  };

  const handleBrokerSearchClear = () => {
    setIsBrokerSearchFocus(true);
    setBrokerSearch("");
  };

  const handleGetBrokerEmailExistsAsync = async (email) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBrokerEmailExists(email) : await getBrokerEmailExists(email, proxyUser.id) as any;
      if (response && response.ok) {
        setIsMessage(false);
        if (response.status === 204) {
          return false;
        }
        else {
          const apiFoundBroker = await response.json();
          if(apiFoundBroker.id){
            setGmrObject({...gmrObject, brokerOrganizationContactId: apiFoundBroker.id });
          }
          
          return apiFoundBroker.email;
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }
  };

  const handleOpenBrokerageListModal = async () => {
    setInvalidProps([]);
    let notValidProps = [] as string[];
    notValidProps = validateObj(newBroker, ["firstName", "lastName", "phone", "brokerEmail"]);
    if (!newBrokerageName) {
      notValidProps.push("organizationName");
    }

    if (notValidProps.length === 0) {
      newBroker.id = guid();
      setIsModalLoading(true);
      const isSearchBrokerageNameSuccess = await handleGetBrokerageNameListAsync(newBrokerageName);
      if (isSearchBrokerageNameSuccess) {
        setNewBrokerageId(guid());
        setNewBrokerageName(newBrokerageName);
        setIsModalLoading(false);
        setIsBrokerageNameModalOpen(true);
        setIsBrokerModalOpen(false);
      }

      setIsModalLoading(false);
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleOpenBrokerageInfoModal = async () => {
    setInvalidProps([]);
    if(brokerageInfo.organizationId) {
      setIsBrokerageInfoModalOpen(true);
      setIsBrokerageNameModalOpen(false);
      setBrokerageInfo({...brokerageInfo, isMailingSameAsPhysical: true });
    }
    else {
      setTimeout(() => { 
        setInvalidProps(["organizationId"]);
      }, 50);
    }
  };

  const handleBrokerModalSubmit = async () => {
    setInvalidProps([]);
    let notValidProps = [] as string[];
    if (isNewBrokerage) {
       notValidProps = validateObj(brokerageInfo, ["entitySubTypeId", "physicalStreet", "physicalZipCode", "physicalCityName", "physicalStateName"]);
       if (!brokerageInfo.isMailingSameAsPhysical) {
        notValidProps = validateObj(brokerageInfo, ["entitySubTypeId", "physicalStreet", "physicalZipCode", "physicalCityName", "physicalStateName", "mailingStreet", "mailingCityName", "mailingStateName", "mailingZipCode"]);
       }
    }

    if (notValidProps.length === 0) {
      if (brokerageInfo.isMailingSameAsPhysical) {
        brokerageInfo.mailingStreet = combineAddresses(brokerageInfo.physicalStreet, brokerageInfo.physicalAddressLine2);
        brokerageInfo.mailingZipCode = brokerageInfo.physicalZipCode;
        brokerageInfo.mailingCityName = brokerageInfo.physicalCityName;
        brokerageInfo.mailingStateName = brokerageInfo.physicalStateName;
        brokerageInfo.mailingCountyName = brokerageInfo.physicalCountyName || "";
      }
      else {
        brokerageInfo.mailingStreet = combineAddresses(brokerageInfo.mailingStreet, brokerageInfo.mailingAddressLine2);
      }

      const completedBrokerObj = {...newBroker, ...brokerageInfo};
      completedBrokerObj.physicalStreet = combineAddresses(brokerageInfo.physicalStreet, brokerageInfo.physicalAddressLine2);
      delete completedBrokerObj.isMailingSameAsPhysical;
      delete completedBrokerObj.physicalAddressLine2;
      delete completedBrokerObj.mailingAddressLine2;
      const isApiSuccess = await handleCreateNewBrokerAsync(completedBrokerObj);
      if (isApiSuccess) {
        setIsBrokerageInfoModalOpen(false);
        setIsNewBrokerCreated(true);
        setGmrObject({...gmrObject, brokerOrganizationContactId: newBroker.id});
      }

      setIsModalLoading(false);
    }
    else {
      setTimeout(() => { 
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleCreateNewBrokerAsync = async (newBroker) => {
    setIsModalLoading(true);
    try {
      const response = FeatureFlags.IS_MOCK ? await createMockNewBroker() : await createNewBroker(newBroker, proxyUser.id);
      if (response && response.ok) {
        setIsModalMessage(false);
        if (isAdminBrmOrLo) {
          const allBrokers = await getAllBrokersAsync();
          gmrMetadata.associatedBrokers = allBrokers;
          setGmrMetadata(gmrMetadata);
        }
        
        return true;
      }
      else {
        await handleErrorResponse(response, setIsModalMessage, setErrorResponse);
        setIsModalMessage(true);
      }
    }
    catch (error) {
      setIsModalMessage(false);
    }

    setIsModalLoading(false);
    return false;
  };

  const handleGetBrokerageNameListAsync = async (name) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockSimilarBrokerageNameList() : await getSimilarBrokerageNameList(encodeURI(name), proxyUser.id) as any;
      if (response && response.ok) {
        setIsMessage(false);
        const companyList = await response.json();
        setSimilarBrokerageList([...companyList]);
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const handleUserIsLoanOfficer = (gmrMetadata, user) => {
    if (gmrMetadata.loanOfficers && user.organizationContactId) {
      gmrMetadata.loanOfficers.forEach(loanOfficer => {
        if (loanOfficer.id === user.organizationContactId) {
          setDefaultLoanOfficer(user.organizationContactId);
          setGmrObject({...gmrObject, loanOfficerOrganizationContactId: user.organizationContactId });
          return user.organizationContactId;
        }
      });
    }

    return false;
  };

  const handleBorrowerTitle = (projectName) => {
    return `Borrowing Information${projectName ? ` for ${projectName}` : ""}`;
  };

  const handleBorrowerSelectionFormChange = async (value, field) => {
    await handleGetBorrowerEntityAsync(value);
    const foundBorrower = associatedBorrowers.find(gmrBorrower => gmrBorrower.id === value);
    if (foundBorrower) {
      handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.STRING);
    }
  };

  const handleIsBorrowerFormChange = async (value, field) => {
    if (value === false) {
      delete newBorrowerEntity.name;
      delete newBorrowerEntity.entitySubTypeId;
      delete newBorrowerEntity.physicalStreet;
      delete newBorrowerEntity.physicalCityName;
      delete newBorrowerEntity.physicalStateName;
      delete newBorrowerEntity.physicalCountyName;
      delete newBorrowerEntity.physicalZipCode;
    }

    handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.STRING);
  };

  const OverviewQuestions = {
    LoanProgram: {
      field: "loanProgramId",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="radio"
            inputArray={gmrMetadata.loanPrograms}
            label="What type of loan are you looking for?"
            obj={gmrObject}
            field="loanProgramId"
            valueField="id"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.STRING, handleCustomFormChange)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="loanProgramId" />
        </Grid.Column>
      </Grid.Row>
    },
    PropertyType: {
      field: "propertyTypeId",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="radio"
            inputArray={gmrMetadata.propertyTypes}
            label={(gmrObject.loanProgramId && [GlobalConstants.LoanProgramIds.BRIDGE, GlobalConstants.LoanProgramIds.FIX_AND_FLIP].indexOf(gmrObject.loanProgramId) > -1) ?
              "What type of structure exists on the property?" : "What type of structure(s) will be built?"}
            obj={gmrObject}
            field="propertyTypeId"
            valueField="id"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="propertyTypeId" />
        </Grid.Column>
      </Grid.Row>
    },
    Name: {
      field: "name",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="input"
            inputKey="pricing-overview"
            label="What is the name of the project?"
            placeholder="Builders Condos"
            obj={gmrObject}
            field="name"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, undefined, undefined, 50)}
          />
          <BCValidationMessage invalidProps={invalidProps} prop="name" />
        </Grid.Column>
      </Grid.Row>
    },
    Zip: {
      field: "projectZipCode",
      content: <React.Fragment>
        <Grid.Row className="application-row">
          <Grid.Column width={16}>
            <BCFormInput
              label="What Zip Code is the project located in?"
              type={GlobalConstants.FormInputTypes.PLACES}
              inputKey="pricing-overview"
              placeDetailsObject={gmrObject}
              setPlaceDetailsObject={setGmrObject}
              placeholder="98103"
              defaultValue={gmrObject.projectZipCode}
              placeFields={["city", "state", "county", "zip"]}
              placeFieldsNameOverrides={[
                {
                  addressComponent: "zip",
                  field: "projectZipCode"
                },
                {
                  addressComponent: "city",
                  field: "cityName"
                },
                {
                  addressComponent: "state",
                  field: "stateName"
                },
                {
                  addressComponent: "county",
                  field: "countyName"
                }
              ]}
              handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
              autofillOverrides={["zip"]}
              fieldType={GlobalConstants.InputTypes.ZIP}
              searchScopeOptions={GlobalConstants.ZipSearchScopeOptions}
              required
            />
            {invalidProps.includes("projectZipCode") ? <BCValidationMessage invalidProps={invalidProps} prop="projectZipCode" /> :
              <BCValidationMessage invalidProps={invalidProps} prop="custom-zip-projectZipCode" propText="This zip code is invalid." />}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="application-row" columns={isGreaterThanMobile ? 3 : 1}>
          <Grid.Column>
            <BCFormInput
              type="input"
              inputKey="pricing-overview"
              label="City"
              obj={gmrObject}
              field="cityName"
              inputType="text"
              disabled
            />
          </Grid.Column>
          <Grid.Column>
            <BCFormInput
              type="input"
              inputKey="pricing-overview"
              label="County"
              obj={gmrObject}
              field="countyName"
              inputType="text"
              disabled
            />
          </Grid.Column>
          <Grid.Column>
            <BCFormInput
              type="input"
              inputKey="pricing-overview"
              label="State"
              obj={gmrObject}
              field="stateName"
              inputType="text"
              disabled
            />
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    }
  };

  const BudgetQuestions = {
    PurchaseOrRefinanceOption: {
      field: "purchaseRefinanceOptionLookupId",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="radio"
            inputArray={handlePurchaseOrRefinanceOptions(gmrMetadata.purchaseOrRefinanceOption)}
            label="Will the property be purchased, refinanced or is it owned outright?"
            obj={gmrObject}
            field="purchaseRefinanceOptionLookupId"
            valueField="id"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="purchaseRefinanceOptionLookupId" />
        </Grid.Column>
      </Grid.Row>
    },
    RefinancePayoff: {
      field: "refinancePayoff",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="pricing-budget"
            label={gmrObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.PURCHASE ? "What is the purchase price?" :
              gmrObject.purchaseRefinanceOptionLookupId === GlobalConstants.PurchaseOrRefinanceOptionIds.REFINANCE_EXTERNAL ? "What is the estimated payoff?" :
                "What is the expected cash back at closing, if any?"}
            placeholder="10000"
            obj={gmrObject}
            field="refinancePayoff"
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.FLOAT)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="refinancePayoff" />
        </Grid.Column>
      </Grid.Row>
    },
    AsIsValue: {
      field: "asIsValue",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="pricing-budget"
            label="What is the As-Is-Value of the property?"
            placeholder="10000"
            obj={gmrObject}
            field="asIsValue"
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.FLOAT)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="asIsValue" />
        </Grid.Column>
      </Grid.Row>
    },
    RequestedBudget: {
      field: "budget",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="pricing-budget"
            label="What is the requested rehab/construction budget?"
            placeholder="10000"
            obj={gmrObject}
            field="budget"
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.FLOAT)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="budget" />
        </Grid.Column>
      </Grid.Row>
    },
    AfterRepairValue: {
      field: "afterRepairValue",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="pricing-budget"
            label="What is the expected finished value of the project?"
            placeholder="10000"
            obj={gmrObject}
            field="afterRepairValue"
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.FLOAT)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="afterRepairValue" />
        </Grid.Column>
      </Grid.Row>
    }
  };

  const ProjectQuestions = {
    Properties: {
      field: "numberOfPropertiesOrUnits",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="input"
            inputKey="pricing-project"
            label="How many properties are in the project?"
            placeholder="1"
            obj={gmrObject}
            field="numberOfPropertiesOrUnits"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.PROPERTIES, handleCustomFormChange)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="numberOfPropertiesOrUnits" />
        </Grid.Column>
      </Grid.Row>
    },
    BuildTime: {
      field: "totalBuildTimeInMonths",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="dropdown"
            inputKey="pricing-project"
            label={gmrObject[OverviewQuestions.LoanProgram.field] === GlobalConstants.LoanProgramIds.DEVELOPMENT ? "How many months will it take to complete development" :
              "How many months will it take to build each property?"}
            placeholder="Please Select"
            obj={gmrObject}
            field="totalBuildTimeInMonths"
            dropdownOptions={getDropdownOptions(handleCalculateValidBuildTimes())}
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, "int", handleCustomFormChange)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="totalBuildTimeInMonths" />
        </Grid.Column>
      </Grid.Row>
    },
    MonthOfFirstDraw: {
      field: "gmrUnitDrawMonths",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            label="Month Of First Draw"
          />
        </Grid.Column>
        {(gmrObject.gmrUnitDrawMonths && gmrObject[OverviewQuestions.LoanProgram.field] !== GlobalConstants.LoanProgramIds.DEVELOPMENT) && gmrObject.gmrUnitDrawMonths.map((item, i) => {
          return (
            <Grid.Column key={`firstdraw-column-${i}`} width={8}>
              <BCFormInput
                labelClass="gmr-background-label"
                type="input"
                inputKey={`pricing-project-${i+1}`}
                label={"Unit " + (i+1)}
                placeholder="1"
                obj={gmrObject}
                field="monthOfFirstDraw"
                inputType="text"
                value={item && item.monthOfFirstDraw ? item.monthOfFirstDraw : ""}
                handleFormChange={(value) => handleMonthOfFirstDrawFormChange(value, i)}
                required
              />
              <BCValidationMessage invalidProps={invalidProps} prop={`gmrUnitDrawMonths-monthOfFirstDraw-${i}`} />
            </Grid.Column>
          );
        })}
        {gmrObject[OverviewQuestions.LoanProgram.field] === GlobalConstants.LoanProgramIds.DEVELOPMENT && <Grid.Column width={8}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            label="Unit 1"
            placeholder="1"
            obj={gmrObject}
            field="monthOfFirstDraw"
            inputType="text"
            value={gmrObject.gmrUnitDrawMonths && gmrObject.gmrUnitDrawMonths[0] ? gmrObject.gmrUnitDrawMonths[0].monthOfFirstDraw : ""}
            handleFormChange={(value) => handleMonthOfFirstDrawFormChange(value, 0)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop={"gmrUnitDrawMonths-monthOfFirstDraw-0"} />
        </Grid.Column>}
      </Grid.Row>
    }
  };

  const FinancingQuestions = {
    LoanTerm: {
      field: "requestedLoanTermInMonths",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="dropdown"
            inputKey="pricing-financing"
            label="Requested Loan Term In Months"
            placeholder="Please Select"
            obj={gmrObject}
            field="requestedLoanTermInMonths"
            dropdownOptions={getDropdownOptions(handleCalculateRequestedLoanTerm())}
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="requestedLoanTermInMonths" />
        </Grid.Column>
      </Grid.Row>
    },
    UseInterestReserve: {
      field: "useInterestReserve",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="radio"
            inputArray={InterestReserveRadios}
            label="Would you prefer to establish an interest reserve or to make monthly payments?"
            obj={gmrObject}
            field="useInterestReserve"
            valueField="value"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="useInterestReserve" />
        </Grid.Column>
      </Grid.Row>
    },
    CashDown: {
      field: "cashDown",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput 
            type="input" 
            inputKey="pricing-financing"
            label="What is the requested cash down payment?"
            placeholder="10000"
            obj={gmrObject}
            field="cashDown"
            fieldType="dollar"
            inputType="number"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.FLOAT)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="cashDown" />
        </Grid.Column>
      </Grid.Row>
    },
    HasPaidCosts: {
      field: "paidCosts",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="radio"
            inputArray={YesNoRadios}
            label="Have any costs been paid on the project to date?"
            obj={gmrObject}
            field="paidCosts"
            valueField="value"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="paidCosts" />
        </Grid.Column>
      </Grid.Row>
    },
    CostsPaid: {
      field: "gmrCostPaids",
      content: <Grid.Row className="application-row">
        <React.Fragment>
          {isGreaterThanMobile ? <React.Fragment>
            <Grid.Column width={16}>
              <Form.Field>
                <label className="gmr-field-label">Total Costs Paid to Project to Date</label>
              </Form.Field>
            </Grid.Column>
            <Grid.Column width={5}>
              <BCFormInput labelClass="gmr-background-label" label="Cost" required />
            </Grid.Column>
            <Grid.Column width={4}>
              <BCFormInput labelClass="gmr-background-label" label="Amount" required />
            </Grid.Column>
            <Grid.Column width={5}>
              <BCFormInput labelClass="gmr-background-label" label="Description" />
            </Grid.Column>
            <Grid.Column width={1} />
              {gmrObject.gmrCostPaids && gmrObject.gmrCostPaids.map((item, i) => {
                return (
                  <React.Fragment key={`paid-cost-${i}`}>
                    <Grid.Column width={5}>
                      <BCFormInput
                        type="dropdown"
                        inputKey={`pricing-background-${i}`}
                        placeholder="Please Select"
                        obj={gmrObject}
                        field="gmrprojectCostId"
                        dropdownOptions={getDropdownOptions(gmrMetadata.costTypes, ["id"], "name")}
                        value={item.gmrprojectCostId ? item.gmrprojectCostId : ""}
                        handleFormChange={(value) => handleCostsPaidToDateFormChange(value, i, "gmrprojectCostId")}
                      />
                      <BCValidationMessage invalidProps={invalidProps} prop={`gmrCostPaids-gmrprojectCostId-${i}`} />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <BCFormInput
                        type="input"
                        inputKey={`pricing-background-${i}`}
                        placeholder="10000"
                        obj={gmrObject}
                        field="amount"
                        fieldType="dollar"
                        inputType="text"
                        value={item.amount || item.amount === 0 ? item.amount : ""}
                        handleFormChange={(value, field) => handleCostsPaidToDateFormChange(value, i, "amount", GlobalConstants.InputTypes.FLOAT)}
                      />
                      <BCValidationMessage invalidProps={invalidProps} prop={`gmrCostPaids-amount-${i}`} />
                    </Grid.Column>
                    <Grid.Column width={5}>
                      <BCFormInput
                        type="input" 
                        inputKey={`pricing-background-${i}`}
                        obj={gmrObject}
                        field="description"
                        inputType="text"
                        value={item.description ? item.description : ""}
                        handleFormChange={(value, field) => handleCostsPaidToDateFormChange(value, i, "description")}
                      />
                    </Grid.Column>
                    <Grid.Column width={2}>
                      {(gmrObject.gmrCostPaids.length > 1) && <Button icon onClick={() => handleRemoveCostsPaid(i)}>
                        <Icon className="gmr-step-icon" name="trash" size="large" />
                      </Button>}
                    </Grid.Column>
                  </React.Fragment>
                );
              })}
            <Grid.Column width={16}>
              <Button className={brokerColor ? brokerButtonOverrideCSS : "bp-button gmr-costs-paid-button"} icon onClick={() => handleAddCostsPaid()}>
                <div className="gmr-button-container">
                  <Icon name='add' size="large" />
                  <div className="gmr-button-icon-text">Add</div>
                </div>
              </Button>
            </Grid.Column>
          </React.Fragment> : <React.Fragment>
            {gmrObject.gmrCostPaids && gmrObject.gmrCostPaids.map((item, i) => {
              return (
                <React.Fragment>
                  <Grid.Column className="application-column-border" width={16}>
                    <div className="form-input-header form-input-border">
                      <label className="form-list-input-label">Paid Cost {i + 1}</label>
                      {(gmrObject.gmrCostPaids.length > 1) && <Button icon onClick={() => handleRemoveCostsPaid(i)}>
                        <Icon name="trash" size="large" />
                      </Button>}
                    </div>
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <BCFormInput
                      labelClass="gmr-background-label"
                      type="dropdown"
                      label="Cost"
                      placeholder="Please Select"
                      obj={gmrObject}
                      field="state"
                      dropdownOptions={getDropdownOptions(gmrMetadata.costTypes, ["id"], "name")}
                      value={item.gmrprojectCostId ? item.gmrprojectCostId : ""}
                      handleFormChange={(value, field) => handleCostsPaidToDateFormChange(value, i, "gmrprojectCostId")}
                      required
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`gmrCostPaids-gmrprojectCostId-${i}`} />
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <BCFormInput
                      labelClass="gmr-background-label"
                      type="input"
                      label="Amount"
                      placeholder="10000"
                      obj={gmrObject}
                      field="address"
                      inputType="text"
                      value={item.amount || item.amount === 0 ? item.amount : ""}
                      handleFormChange={(value, field) => handleCostsPaidToDateFormChange(value, i, "amount", GlobalConstants.InputTypes.FLOAT)}
                      required
                    />
                    <BCValidationMessage invalidProps={invalidProps} prop={`gmrCostPaids-amount-${i}`} />
                  </Grid.Column>
                  <Grid.Column width={16}>
                    <BCFormInput
                      labelClass="gmr-background-label"
                      type="input"
                      label="Description"
                      obj={gmrObject}
                      field="address"
                      inputType="text"
                      value={item.description ? item.description : ""}
                      handleFormChange={(value, field) => handleCostsPaidToDateFormChange(value, i, "description")}
                      required
                    />
                  </Grid.Column>
                </React.Fragment>
              );
            })}
            <Grid.Column width={16}>
              <Button className={brokerColor ? brokerButtonOverrideCSS : "bp-button gmr-costs-paid-button"} icon onClick={() => handleAddCostsPaid()}>
                <div className="gmr-button-container">
                  <Icon name='add' size="large" />
                  <div className="gmr-button-icon-text">Add</div>
                </div>
              </Button>
            </Grid.Column>
          </React.Fragment>}
        </React.Fragment>
      </Grid.Row>
    }
  };

  const BackgroundQuestions = {
    ProjectExperience: {
      field: "projectExperience",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="input"
            inputKey="pricing-background"
            label="What is the cumulative project experience of the Borrowing Entity and Guarantor(s) in the last 18 months?"
            placeholder="5"
            obj={gmrObject}
            field="projectExperience"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, "int")}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="cumulativeProjectExperience" />
        </Grid.Column>
      </Grid.Row>
    },
    CreditScore: {
      field: "creditScore",
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput
            type="input"
            inputKey="pricing-background"
            label="What is the estimated best credit score of the Guarantor(s)?"
            placeholder="700"
            obj={gmrObject}
            field="creditScore"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.CREDIT)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="creditScore" />
        </Grid.Column>
      </Grid.Row>
    },
    BrokerAssociatedWithLoan: {
      field: "isBrokerInvolved",
      content: <Grid.Row className="application-row">
        <BPAssociatedBrokerQuestion 
          obj={gmrObject} 
          handleFormChange={handleAssociatedBrokerChange}
          invalidProps={invalidProps}
          flow={GlobalConstants.Flow.GMR}
        />
      </Grid.Row>
    },
    BrokerEmail: {
      field: "brokerSearchEmail",
      content: <Grid.Row className="application-row">
        <BPBrokerEmailQuestion
          isBrokerSelected={(isNewBrokerCreated || selectedBrokerEmail !== "")}
          handleAddBroker={handleAddBroker}
          handleOnSearchChange={handleBrokerSearchChange}
          obj={gmrObject}
          value={brokerSearch}
          handleRenderSuggestions={handleDoubleFilterBrokerSuggestions}
          handleSearchSelect={handleBrokerSelect}
          isSearchOpen={isBrokerSearchFocus}
          onSearchFocus={setIsBrokerSearchFocus}
          handleSearchKeyDown={handleBrokerSearchKeyDown}
          invalidProps={invalidProps}
          flow={GlobalConstants.Flow.GMR}
        />
      </Grid.Row>
    },
    BrokerFeeRate: {
      fields: ["brokerFeeRate", "wlbrokerFeeRate"],
      content: <Grid.Row className="application-row">
        {(persona === Personas.BROKER || (!FeatureFlags.IS_BETA && isAdminBrmOrLo) || 
          ((isAdminBrmOrLo) && gmrObject.isBrokerInvolved === true)) && <BPBrokerFeeRateQuestion 
          obj={gmrObject}
          setObj={setGmrObject}
          handleFormChange={(value, field, obj, setObj, inputType) => handleFormChange(value, field, gmrObject, setGmrObject, inputType, handleCustomFormChange)}
          handleCustomFormChange={handleCustomFormChange}
          invalidProps={invalidProps}
          flow={GlobalConstants.Flow.GMR}
          metadata={gmrMetadata}
        />}
      </Grid.Row>
    },
    SelectLoanOfficer: {
      field: "loanOfficerOrganizationContactId",
      content: <Grid.Row className="application-row">
        <BPSelectLoanOfficerQuestion 
          obj={gmrObject}
          setObj={setGmrObject}
          value={gmrObject.loanOfficerOrganizationContactId || handleUserIsLoanOfficer(gmrMetadata, user)}
          dropdownOptions={getDropdownOptions(gmrMetadata.loanOfficers ? gmrMetadata.loanOfficers : [], ["id"], "name")}
          handleFormChange={handleFormChange}
          invalidProps={invalidProps}
          flow={GlobalConstants.Flow.GMR}
        />
      </Grid.Row>
    },
    ContactInformation: {
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput labelClass="primary-title-label form-input-header form-input-border" label="Contact Information" />
        </Grid.Column>
        <Grid.Column width={8}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="first-name"
            label="First Name"
            placeholder="John"
            obj={gmrObject}
            field="firstName"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="firstName" />
        </Grid.Column>
        <Grid.Column width={8}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="last-name"
            label="Last Name"
            placeholder="Smith"
            obj={gmrObject}
            field="lastName"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="lastName" />
        </Grid.Column>
        <Grid.Column width={16}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="radio"
            inputArray={["Email", "Phone"]}
            label="Preferred Contact Method"
            obj={gmrObject}
            field="preferredContactMethodOption"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.STRING)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="preferredContactMethodOption" />
        </Grid.Column>
        <Grid.Column width={8}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="email"
            label="Email"
            placeholder="john.smith@gmail.com"
            obj={gmrObject}
            field="email"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="email" />
        </Grid.Column>
        <Grid.Column width={8}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="phone"
            label="Phone"
            placeholder="2061234567"
            obj={gmrObject}
            field="phone"
            fieldType="phone"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, GlobalConstants.InputTypes.MASKED)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="phone" />
        </Grid.Column>
        <Grid.Column width={16}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="dropdown"
            inputKey="loan-officer"
            label="Select the loan officer"
            placeholder="Please Select"
            obj={gmrObject}
            field="loanOfficerOrganizationContactId"
            dropdownOptions={getDropdownOptions(gmrMetadata.loanOfficers ? gmrMetadata.loanOfficers : [], ["id"], "name")}
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="loanOfficerOrganizationContactId" />
        </Grid.Column>
      </Grid.Row>
    },
    BorrowerEntity: {
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <BCFormInput labelClass="primary-title-label form-input-header form-input-border" label="Borrowing Entity" />
        </Grid.Column>
        <Grid.Column width={16}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="input"
            inputKey="entity-company-name"
            label="Company Name"
            placeholder="Smith"
            obj={gmrObject}
            field="borrowerCompanyName"
            inputType="text"
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="borrowerCompanyName" />
        </Grid.Column>
        <Grid.Column width={16}>
          <BCFormInput
            labelClass="gmr-background-label"
            type="dropdown"
            label="Company Type"
            placeholder="Please Select"
            obj={gmrObject}
            field="borrowerEntitySubTypeId"
            dropdownOptions={getDropdownOptions(gmrMetadata.entitySubTypes ? gmrMetadata.entitySubTypes : [], ["id"], "name")}
            handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject)}
            required
          />
          <BCValidationMessage invalidProps={invalidProps} prop="borrowerEntitySubTypeId" />
        </Grid.Column>
        <Grid.Column width={16}><div className="gmr-disclaimer">{borrowerEntityDisclaimer1}</div></Grid.Column>
        <Grid.Column width={16}><div className="gmr-disclaimer">{borrowerEntityDisclaimer2}</div></Grid.Column>
      </Grid.Row>
    },
    BorrowerSelection: {
      content: <BPBorrowerEntitySelection
        obj={gmrObject}
        handleApplicationFormChange={(value, field) => handleIsBorrowerFormChange(value, field)}
        handleBorrowerFormChange={(value, field) => handleBorrowerSelectionFormChange(value, field)}
        dropdownOptions={getDropdownOptions(associatedBorrowers, ["id"], "name")}
        invalidProps={invalidProps}
        brokerColor={brokerColor}
      />
    },
    BorrowerContact: {
      content: <BPBorrowerEntityAdditionalInformation
        obj={gmrObject}
        brokerColor={brokerColor}
        isGreaterThanMobile={isGreaterThanMobile}
        entityObj={newBorrowerEntity}
        setEntityObj={setNewBorrowerEntity}
        handleEntityFormChange={(value, field) => handleFormChange(value, field, newBorrowerEntity, setNewBorrowerEntity)}
        invalidProps={invalidProps}
        entityDropdownOptions={getDropdownOptions(gmrMetadata.entitySubTypes ? gmrMetadata.entitySubTypes : [], ["id"], "name")}
      />
    }
  };

  const GetMyRateQuestions = {
    Calculation: {
      content: <Grid.Row className="application-row">
        <Grid.Column width={16}>
          <React.Fragment>
            <Header className="primary-accordion-header" as='h2' dividing>Pricing Proposal - {gmrObject.name}
              <div className="landing-page-menu-container">
                <div className="landing-page-button-group">
                  {(FeatureFlags.IS_BC_PRICING && !isAnonymous) && <React.Fragment>
                    <Button
                      className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
                      icon
                      basic
                      loading={exportLoading}
                      onClick={() => handleAddScenario()}
                      disabled={gmrScenarios && gmrScenarios.length >= 2}
                    >
                      <div className="gmr-button-container">
                        <Icon name='add' size="large" />
                        <div className="gmr-button-icon-text">Add Scenario</div>
                      </div>
                    </Button>
                    <Button
                      className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
                      icon
                      basic
                      loading={exportLoading}
                      onClick={() => handleRecalculate(gmrScenarios)}
                      disabled={!isRecalculateValid}
                    >
                      <div className="gmr-button-container">
                        <Icon name='redo' size="large" />
                        <div className="gmr-button-icon-text">Re-Calculate</div>
                      </div>
                    </Button>
                    <Button
                      className={getIsWhiteLabeled() ? `details-button ${brokerButtonOverrideCSS}` : "bp-button details-button"}
                      icon
                      basic
                      loading={exportLoading}
                      onClick={() => handleExportOnClick()}
                    >
                      <div className="gmr-button-container">
                        <Icon name='share square' size="large" />
                        <div className="gmr-button-icon-text">Export</div>
                      </div>
                    </Button>
                    {(FeatureFlags.IS_BETA && gmrObject.isBrokerInvolved && isAdminBrmOrLo) && <Button
                      className={"bp-button details-button"}
                      icon
                      basic
                      loading={exportLoading}
                      onClick={() => handleSendToBrokerButton()}
                    >
                      <div className="gmr-button-container">
                        <Icon name="envelope" size="large" />
                        <div className="gmr-button-icon-text">{sendToBroker}</div>
                      </div>
                    </Button>}
                  </React.Fragment>}
                </div>
              </div>
            </Header>
            <BCModal
              isModalOpen={scenarioModal}
              brokerColor={brokerColor}
              size={"large"}
              onClose={() => setScenarioModal(false)}
              onOpen={() => setScenarioModal(true)}
              actions={<Button className="bp-button" icon fluid onClick={() => setScenarioModal(false)}>Close</Button>}
              header={"First Step is Done! Check out your quote:"}
              content={<Table className="gmr-table" textAlign="center" unstackable columns={4}>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      Loan Commitment:
                    </Table.Cell>
                    <Table.Cell>
                      {gmrCalculationObject.loanCommitment ? convertToDollar(gmrCalculationObject.loanCommitment) : "$0.00"}
                    </Table.Cell>
                    <Table.Cell>
                      Refinance Payoff:
                    </Table.Cell>
                    <Table.Cell>
                      {convertToDollar(gmrCalculationObject.refinancePayoff)}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Interest rate:
                    </Table.Cell>
                    <Table.Cell>
                      {gmrCalculationObject.interestRate && convertToMinFraction(gmrCalculationObject.interestRate, 3, 3) + "%"}
                    </Table.Cell>
                    <Table.Cell>
                      LTV:
                    </Table.Cell>
                    <Table.Cell>
                      {gmrCalculationObject.ltv ? convertToMinFraction(gmrCalculationObject.ltv, 3, 3) + "%" : "0.0%"}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Origination Fee (%):
                    </Table.Cell>
                    <Table.Cell>
                      {gmrCalculationObject.originationFeeRate && convertToMinFraction(gmrCalculationObject.originationFeeRate, 3, 3) + "%"}
                    </Table.Cell>
                    <Table.Cell>
                      LTC:
                    </Table.Cell>
                    <Table.Cell>
                      {gmrCalculationObject.ltc ? convertToMinFraction(gmrCalculationObject.ltc, 3, 3) + "%" : "0.0%"}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Term (Months):
                    </Table.Cell>
                    <Table.Cell>
                      {gmrCalculationObject.requestedLoanTermInMonths}
                    </Table.Cell>
                    <Table.Cell>
                      Budget
                    </Table.Cell>
                    <Table.Cell>
                      {convertToDollar(gmrCalculationObject.budget)}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>
                      Estimated Cash Down:
                    </Table.Cell>
                    <Table.Cell>
                      {convertToDollar(gmrCalculationObject.cashDown)}
                    </Table.Cell>
                    <Table.Cell>
                      Finished Value:
                    </Table.Cell>
                    <Table.Cell>
                      {convertToDollar(gmrCalculationObject.afterRepairValue)}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>}
            />
          </React.Fragment>
        </Grid.Column>
        <div className="padding">
          <BPPricingScenario
            isGreaterThanMobile={isGreaterThanMobile}
            isGreaterThanTablet={isGreaterThanTablet}
            isSidebar={isSidebar}
            gmrObject={gmrObject}
            setGmrObject={setGmrObject}
            gmrMetadata={gmrMetadata}
            associatedBorrowers={associatedBorrowers}
            gmrScenarios={gmrScenarios}
            setGmrScenarios={setGmrScenarios}
            permissions={permissions}
            setIsRecalculateValid={setIsRecalculateValid}
            isAnonymous={isAnonymous}
            persona={persona}
          />
          {isAnonymous && <React.Fragment>
            <div className="gmr-disclaimer">{borrowerEntityDisclaimer3}</div>
            <div className="gmr-disclaimer">{borrowerEntityDisclaimer4}</div>
            <div className="gmr-disclaimer">{borrowerEntityDisclaimer5}</div>
          </React.Fragment>}
        </div>
      </Grid.Row>
    }
  };

  const OverviewSteps = {
    LoanProgram: {
      id: OverviewLoanProgramStepId,
      questions: [OverviewQuestions.LoanProgram],
      validatingProps: [OverviewQuestions.LoanProgram.field],
      customNext: true
    },
    PropertyType: {
      id: "b01ba338-82b8-4ac4-a262-eab3882894bb",
      questions: [OverviewQuestions.PropertyType],
      validatingProps: [OverviewQuestions.PropertyType.field]
    },
    Name: {
      id: "08ef7570-0cc0-4314-9891-ed5fa01e0f28",
      questions: [OverviewQuestions.Name],
      validatingProps: [OverviewQuestions.Name.field]
    },
    Zip: {
      id: "9473e4c7-31ef-4d4a-939c-0384bf1c8e5e",
      questions: [OverviewQuestions.Zip],
      validatingProps: [OverviewQuestions.Zip.field]
    }
  };

  const BudgetSteps = {
    PurchaseOrRefinanceOption: {
      id: "afa8c223-37ef-474c-a458-b5923d7c697c",
      questions: [BudgetQuestions.PurchaseOrRefinanceOption],
      validatingProps: [BudgetQuestions.PurchaseOrRefinanceOption.field]
    },
    RefinancePayoff: {
      id: "572e0ca1-51a8-41e6-a592-44aefc405709",
      questions: [BudgetQuestions.RefinancePayoff],
      validatingProps: [BudgetQuestions.RefinancePayoff.field]
    },
    AsIsValue: {
      id: "af7d7356-3b77-4b97-9e15-0e7614dec265",
      questions: [BudgetQuestions.AsIsValue],
      validatingProps: [BudgetQuestions.AsIsValue.field]
    },
    RequestedBudget: {
      id: "b7a9bd6a-002d-46a0-ac52-9c525bfd2d60",
      questions: [BudgetQuestions.RequestedBudget],
      validatingProps: [BudgetQuestions.RequestedBudget.field]
    },
    AfterRepairValue: {
      id: "d902254d-b256-4df6-8eeb-838445b0a812",
      questions: [BudgetQuestions.AfterRepairValue],
      validatingProps: [BudgetQuestions.AfterRepairValue.field]
    },
  };

  const ProjectSteps = {
    Properties: {
      id: "5cac08d8-6f56-4919-86e1-ddc7344a23af",
      questions: [ProjectQuestions.Properties],
      customNext: true
    },
    BuildTime: {
      id: "d5e4d631-083c-4adb-9b6c-bef922fba1ff",
      questions: [ProjectQuestions.BuildTime],
      validatingProps: [ProjectQuestions.BuildTime.field]
    },
    MonthOfFirstDraw: {
      id: "40083e34-8706-484a-8e11-5beb1f37f0b6",
      questions: [ProjectQuestions.MonthOfFirstDraw]
    },
  };

  const FinancingSteps = {
    LoanTerm: {
      id: "e0ff05a8-45ab-437b-9deb-02271ee2880a",
      questions: [FinancingQuestions.LoanTerm],
      validatingProps: [FinancingQuestions.LoanTerm.field]
    },
    UseInterestReserve: {
      id: "76c9cade-7f0a-456c-9cc7-c774dc3afde1",
      questions: [FinancingQuestions.UseInterestReserve],
      validatingProps: [FinancingQuestions.UseInterestReserve.field]
    },
    CashDown: {
      id: "df82dc7a-59b7-4335-ba59-571118eca570",
      questions: [FinancingQuestions.CashDown],
      validatingProps: [FinancingQuestions.CashDown.field]
    },
    HasPaidCosts: {
      id: "cd0192b4-08f8-48f2-ace6-286e0227f14f",
      questions: [FinancingQuestions.HasPaidCosts],
      validatingProps: [FinancingQuestions.HasPaidCosts.field],
      customNext: true
    },
    CostsPaid: {
      id: "71eb0128-ad96-4176-a2a8-e1bea178ae5c",
      questions: [FinancingQuestions.CostsPaid]
    }
  };

  const BackgroundSteps = {
    ProjectExperience: {
      id: "e43a5e67-81c1-44ed-b688-601cd07965d4",
      questions: [BackgroundQuestions.ProjectExperience],
      validatingProps: [BackgroundQuestions.ProjectExperience.field]
    },
    CreditScore: {
      id: "3f53a744-cbfd-4b1b-b9c3-94dae09f7642",
      questions: [BackgroundQuestions.CreditScore],
      validatingProps: [BackgroundQuestions.CreditScore.field]
    },
    BrokerFeeRate: {
      id: "9566ac07-ab3d-4114-8b6c-36a6f64e9161",
      questions: isAdminBrmOrLo ? [BackgroundQuestions.BrokerAssociatedWithLoan, BackgroundQuestions.BrokerEmail, BackgroundQuestions.BrokerFeeRate, BackgroundQuestions.SelectLoanOfficer] 
      : persona === Personas.NWL_GUARANTOR ? [BackgroundQuestions.SelectLoanOfficer] : persona === Personas.LOAN_OFFICER ? [BackgroundQuestions.BrokerAssociatedWithLoan, BackgroundQuestions.BrokerEmail, BackgroundQuestions.BrokerFeeRate, BackgroundQuestions.SelectLoanOfficer]
      : [BackgroundQuestions.BrokerFeeRate, ...((persona === Personas.BROKER && FeatureFlags.IS_BETA) ? [BackgroundQuestions.SelectLoanOfficer] : [])],
      validatingProps: isAdminBrmOrLo ? [BackgroundQuestions.BrokerAssociatedWithLoan.field, BackgroundQuestions.BrokerEmail.field, BackgroundQuestions.SelectLoanOfficer.field].concat(FeatureFlags.IS_BROKER_FEE_ALLIANCE ? BackgroundQuestions.BrokerFeeRate.fields : ["brokerFeeRate", "isCombineOriginationFee"])
      : persona === Personas.NWL_GUARANTOR ? [BackgroundQuestions.SelectLoanOfficer.field] : persona === Personas.LOAN_OFFICER ? [BackgroundQuestions.BrokerAssociatedWithLoan.field, BackgroundQuestions.BrokerEmail.field, BackgroundQuestions.SelectLoanOfficer.field].concat(FeatureFlags.IS_BROKER_FEE_ALLIANCE ? BackgroundQuestions.BrokerFeeRate.fields : ["brokerFeeRate", "isCombineOriginationFee"])
      : FeatureFlags.IS_BROKER_FEE_ALLIANCE ? BackgroundQuestions.BrokerFeeRate.fields : ["brokerFeeRate", "isCombineOriginationFee"],
      customNext: true
    },
    ContactInformation: {
      id: "6b0cd033-8e6b-4598-bd2f-dd01d89c822d",
      questions: [BackgroundQuestions.ContactInformation],
      validatingProps: ["firstName", "lastName", "preferredContactMethodOption", "email", "phone", "loanOfficerOrganizationContactId"]
    },
    BorrowerEntity: {
      id: "f24f916d-5061-4b81-aac9-351fbda9575f",
      questions: [BackgroundQuestions.BorrowerEntity],
      validatingProps: ["borrowerCompanyName", "borrowerEntitySubTypeId"]
    },
    BorrowerSelection: {
      id: "bc00fda8-9991-4cc9-8fea-ddcdce47fec8",
      questions: [BackgroundQuestions.BorrowerSelection],
      validatingProps: []
    },
    BorrowerContact: {
      id: "7971c051-c836-41c2-a6b5-2ec75d515f0f",
      questions: [BackgroundQuestions.BorrowerContact],
      validatingProps: ["name", "entitySubTypeId", "physicalStreet", "physicalZipCode", "physicalCityName", "physicalStateName"]
    }
  };

  const GetMyRateSteps = {
    Calculation: {
      id: "e63773ea-9fed-4a59-ac8a-7383af1d12e4",
      questions: [GetMyRateQuestions.Calculation]
    }
  };

  const handleStepIsActive = (activeStep, inactiveStep) => {
    const currentStepIndex = ApplicationSteps.findIndex(x => x.id === currentStepId);
    const activeStepIndex = ApplicationSteps.findIndex(x => x.id === activeStep.id);
    const inactiveStepIndex = ApplicationSteps.findIndex(x => x.id === inactiveStep.id);
    return (currentStepIndex >= activeStepIndex && currentStepIndex < inactiveStepIndex);
  };

  const handleStepIsDisabled = (disabledStep) => {
    const disabledStepIndex = ApplicationSteps.findIndex(x => x.id === disabledStep.id);
    return furthestStepIndex < disabledStepIndex;
  };

  const ApplicationSteps = [].concat.apply([], [
    Object.values(OverviewSteps) as any,
    Object.values(BudgetSteps) as any,
    Object.values(ProjectSteps) as any,
    Object.values(FinancingSteps) as any,
    Object.values(BackgroundSteps) as any,
    Object.values(GetMyRateSteps) as any
  ]) as any;

  const ApplicationMainSteps = [
    {
      step: OverviewSteps.LoanProgram.id,
      name: "Overview",
      icon: "tasks",
      active: handleStepIsActive(OverviewSteps.LoanProgram, BudgetSteps.PurchaseOrRefinanceOption),
      disabled: handleStepIsDisabled(OverviewSteps.LoanProgram)
    },
    {
      step: BudgetSteps.RefinancePayoff.id,
      name: "Budget",
      icon: "calculator",
      active: handleStepIsActive(BudgetSteps.PurchaseOrRefinanceOption, ProjectSteps.Properties),
      disabled: handleStepIsDisabled(BudgetSteps.PurchaseOrRefinanceOption)
    },
    {
      step: ProjectSteps.Properties.id,
      name: "Project",
      icon: "warehouse",
      active: handleStepIsActive(ProjectSteps.Properties, FinancingSteps.LoanTerm),
      disabled: handleStepIsDisabled(ProjectSteps.Properties)
    },
    {
      step: FinancingSteps.LoanTerm.id,
      name: "Financing",
      icon: "dollar",
      active: handleStepIsActive(FinancingSteps.LoanTerm, BackgroundSteps.ProjectExperience),
      disabled: handleStepIsDisabled(FinancingSteps.LoanTerm)
    },
    {
      step: BackgroundSteps.ProjectExperience.id,
      name: "Background",
      icon: "id card",
      active: handleStepIsActive(BackgroundSteps.ProjectExperience, GetMyRateSteps.Calculation),
      disabled: handleStepIsDisabled(BackgroundSteps.ProjectExperience)
    }
  ];

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const handleRouteToHome = useCallback(() => {
    history.push("/");
  }, [history]);

  const handleRouteToPricing = useCallback(() => {
    history.push("/pricing");
  }, [history]);

  const handleRouteToBorrowerApplication = () => {
    history.push(`/application/borrower/${guid()}`);
  };

  const handleRouteToApplications = () => {
    history.push("/applications");
  };

  const handleSendToBroker = async () => {
    const brokerEmailObj = {
      gmrId: gmrObject.id,
      name: gmrObject.name,
      description: emailBrokerObj.description,
      ccRecepients: selectedRecipients
    };

    setIsSendBrokerEmailLoading(true);
    await sendEmailToBrokerAsync(brokerEmailObj);
    setIsSendBrokerEmailLoading(false);
    setIsScenarioSentToBrokerModal(false);
    setSendToBroker("Re-Send To Broker");
  };

  const handleSendToBrokerButton = async () => {
    setIsScenarioSentToBrokerModal(true);
    await getGmrEmployeesMetadataAsync();
  };

  const handleOnSearchRecipientsChange = async (searchInput) => {
    const searchValue = handleInputType("string", searchInput, undefined, undefined, 50);
    setRecipientSearchInput(searchValue);
    setIsAddingRecipient(true);
    if (searchValue !== "" && internalEmployees && internalEmployees.length > 0) {
      const filteredBrokers = internalEmployees.filter(x => (x.email && ((x.email).toLowerCase().includes(searchValue.toLowerCase()))) || (x.name && ((x.name).toLowerCase().includes(searchValue.toLowerCase()))));
      setRecipientsDropdown(filteredBrokers);
    }
    else if (searchValue === "" && internalEmployees && internalEmployees.length > 0) {
      setRecipientsDropdown(internalEmployees);
    }
    else {
      setRecipientsDropdown([]);
    }
  };

  const handleFilterRecipientSuggestions = (searchInput) => {
    const results = [] as any[];
    let resultLimit = 6;
    let recommendedRecipients = internalEmployees;
    if (searchInput && searchInput !== "") {
      recommendedRecipients = recipientsDropdown;
    }

    if (recommendedRecipients && recommendedRecipients.length > 0) {
      recommendedRecipients.map(employee => {
        const isRecipientSelected = selectedRecipients.find(x => x === employee.email);
        if (resultLimit > 0 && !isRecipientSelected) {
          results.push({
            key: employee.id,
            title: employee.title ? `${employee.name} - ${employee.title}` : employee.name,
            description: employee.email
          });
        }

        resultLimit--;
      });
    }

    return results;
  };

  const handleRecipientSelect = async (result) => {
    if (result && result.description !== "") {
      if (!selectedRecipients.find(x => x === result.description)) {
        setSelectedRecipients([...selectedRecipients, result.description]);
      }

      setRecipientSearchInput("");
      setIsAddingRecipient(false);
    }
  };

  const handleRecipientSearchKeyDown = async (e) => {
    if (e.keyCode === 27) {
      setRecipientSearchInput("");
    }
  };

  const handleLoanApplication = async () => {
    if (gmrScenarios.length === 0) {
      setGmrEditData({ ...gmrObject });
    }
    else {
      const foundGmrScenario = gmrScenarios.find(x => x.name === gmrObject.chosenScenario);
      if (foundGmrScenario) {
        if (isRecalculateValid) {
          await handleRecalculateAsync(gmrScenarios);
          setIsRecalculateValid(false);
        }

        setGmrEditData({ ...foundGmrScenario });
      }
      else {
        setGmrEditData({ ...gmrObject });
      }
    }

    handleRouteToBorrowerApplication();
  };

  const handleNavigateToStep = (stepId) => {
    if (ApplicationSteps.findIndex(x => x.id === stepId) < ApplicationSteps.findIndex(x => x.id === currentStepId)) {
      handlePrev(stepId, true);
    }
    else {
      handleTryNext(stepId);
    }
  };

  const handlePaging = () => {
    setWarningIds([]);
    setInvalidProps([]);
    if (unfocusRef.current) {
      unfocusRef.current.focus();
    }
  };

  const handleProgress = (stepIndex) => {
    const applicationProgress = (100 / (ApplicationSteps.length - 1)) * stepIndex;
    setCurrentProgress(applicationProgress);
  };

  const handlePrev = (stepId = undefined, isSkip = false) => {
    handlePaging();
    const currentStepIndex = ApplicationSteps.findIndex(x => x.id === currentStepId);
    let prevStepIndex = currentStepIndex - 1;
    if (stepId) {
      const specifiedStepIndex = ApplicationSteps.findIndex(x => x.id === stepId);
      prevStepIndex = specifiedStepIndex;
    }

    while (ApplicationSteps[prevStepIndex] && excludedStepIds.includes(ApplicationSteps[prevStepIndex].id)) {
      if (isSkip) {
        prevStepIndex++;
      }
      else {
        prevStepIndex--;
      }
    }

    if (prevStepIndex === -1) {
      handleRouteToPricing();
    }
    else {
      setCurrentStepId(ApplicationSteps[prevStepIndex].id);
      handleProgress(prevStepIndex);
    }

    setPreviousModal(false);
  };

  const handleCustomNext = async (stepId) => {
    let currentExcludedIds = excludedStepIds;
    if (stepId === OverviewSteps.LoanProgram.id) {
      const bridgeExcludeIds = [
        BudgetSteps.RequestedBudget.id,
        BudgetSteps.AfterRepairValue.id,
        ProjectSteps.Properties.id,
        ProjectSteps.BuildTime.id,
        ProjectSteps.MonthOfFirstDraw.id,
        FinancingSteps.UseInterestReserve.id,
        FinancingSteps.HasPaidCosts.id,
        FinancingSteps.CostsPaid.id
      ];

      currentExcludedIds = removeFromArrayByValues(currentExcludedIds, bridgeExcludeIds.concat([OverviewSteps.PropertyType.id]));
      if (gmrObject[OverviewQuestions.LoanProgram.field] === GlobalConstants.LoanProgramIds.BRIDGE) {
        gmrObject[BudgetQuestions.RequestedBudget.field] = 0;
        gmrObject[ProjectQuestions.Properties.field] = 1;
        gmrObject[ProjectQuestions.BuildTime.field] = 1;
        gmrObject[ProjectQuestions.MonthOfFirstDraw.field] = [{
          gmrId: gmrObject.id,
          unitNo: 1,
          monthOfFirstDraw: 1
        }];

        gmrObject[FinancingQuestions.UseInterestReserve.field] = false;
        gmrObject[FinancingQuestions.HasPaidCosts.field] = false;
        if (!(gmrObject[FinancingQuestions.CostsPaid.field] && gmrObject[FinancingQuestions.CostsPaid.field][0] && gmrObject[FinancingQuestions.CostsPaid.field][0].id)) {
          gmrObject[FinancingQuestions.CostsPaid.field] = [];
        }

        currentExcludedIds = excludedStepIds.concat(bridgeExcludeIds);
      }
      else if (gmrObject[OverviewQuestions.LoanProgram.field] === GlobalConstants.LoanProgramIds.DEVELOPMENT) {
        gmrObject[ProjectQuestions.Properties.field] = 1;
        if (!(gmrObject[FinancingQuestions.CostsPaid.field] && gmrObject[FinancingQuestions.CostsPaid.field][0] && gmrObject[FinancingQuestions.CostsPaid.field][0].id)) {
          gmrObject[FinancingQuestions.CostsPaid.field] = [];
        }

        gmrObject[OverviewQuestions.PropertyType.field] = GlobalConstants.PropertyTypeIds.NO_STRUCTURE_LAND;
        currentExcludedIds = excludedStepIds.concat([OverviewSteps.PropertyType.id, ProjectSteps.Properties.id, FinancingSteps.CostsPaid.id]);
      }
      else if (gmrObject[OverviewQuestions.LoanProgram.field] === GlobalConstants.LoanProgramIds.FIX_AND_FLIP) {
        gmrObject[ProjectQuestions.Properties.field] = 1;
        gmrObject[ProjectQuestions.MonthOfFirstDraw.field] = [{ id: guid(), gmrId: gmrObject.id }];
        currentExcludedIds = excludedStepIds.concat([ProjectSteps.Properties.id]);
      }

      setGmrObject({ ...gmrObject });
      setExcludedStepIds([...currentExcludedIds]);
    }
    else if (stepId === ProjectSteps.Properties.id) {
      if (!gmrObject[ProjectQuestions.MonthOfFirstDraw.field] || (gmrObject[ProjectQuestions.MonthOfFirstDraw.field] && gmrObject[ProjectQuestions.MonthOfFirstDraw.field].length !== gmrObject[ProjectQuestions.Properties.field])) {
        gmrObject[ProjectQuestions.MonthOfFirstDraw.field] = [];
        for (let i = 0; i < gmrObject[ProjectQuestions.Properties.field]; i++) {
          gmrObject[ProjectQuestions.MonthOfFirstDraw.field].push({ id: guid(), gmrId: gmrObject.id });
        }
      }

      setGmrObject({ ...gmrObject });
    }
    else if (stepId === FinancingSteps.HasPaidCosts.id) {
      const hasPaidCostsExcludeIds = [FinancingSteps.CostsPaid.id];
      currentExcludedIds = removeFromArrayByValues(currentExcludedIds, hasPaidCostsExcludeIds);
      if (gmrObject[FinancingQuestions.HasPaidCosts.field] === false) {
        currentExcludedIds = excludedStepIds.concat(hasPaidCostsExcludeIds);
        gmrObject[FinancingQuestions.CostsPaid.field] = [];
      }
      else if (gmrObject[FinancingQuestions.HasPaidCosts.field] && ((gmrObject[FinancingQuestions.CostsPaid.field] && gmrObject[FinancingQuestions.CostsPaid.field].length === 0) || 
      !gmrObject[FinancingQuestions.CostsPaid.field])) {
        gmrObject[FinancingQuestions.CostsPaid.field] = [{
          amount: undefined,
          gmrprojectCostId: undefined,
          name: undefined
        }];
      }

      setGmrObject({ ...gmrObject });
      setExcludedStepIds([...currentExcludedIds]);
    }
    else if (stepId === BackgroundSteps.BrokerFeeRate.id && !isAllBorrowersPersona) {
      await handleAssociatedBorrowers(
        isAllBorrowersPersona, 
        handleAssociatedOrganizationContactId(gmrObject, persona === Personas.BROKER && user.organizationContactId),
        setAssociatedBorrowers,
        proxyUser,
        setIsMessage,
        setErrorResponse
      );
    }

    return currentExcludedIds;
  };

  const handleValidation = (step) => {
    const validatingProps = step.validatingProps ? step.validatingProps : [];
    let notValidProps = validateObj(gmrObject, validatingProps);
    if (FeatureFlags.IS_BETA && step.id === BackgroundSteps.BrokerFeeRate.id && (isAdminBrmOrLo || 
      persona === Personas.LOAN_OFFICER)) {
      if (Object.keys(gmrObject).includes("isBrokerInvolved")){
        if (gmrObject.isBrokerInvolved) {
          if (gmrObject.brokerSearchEmail && !gmrObject.brokerOrganizationContactId) {
            notValidProps = validateObj(gmrObject, [...validatingProps, "brokerOrganizationContactIdError"]);
          }
          else {
            notValidProps = validateObj(gmrObject, [...validatingProps, "brokerOrganizationContactId"]);
          }
        }
        else {
          notValidProps = validateObj(gmrObject, ["loanOfficerOrganizationContactId"]);
        }
      }
      else {
        notValidProps = validateObj(gmrObject, ["isBrokerInvolved"]);
      }
    }
    else if (!FeatureFlags.IS_BETA && step.id === BackgroundSteps.BrokerFeeRate.id) {
      notValidProps = validateObj(gmrObject, FeatureFlags.IS_BROKER_FEE_ALLIANCE ? BackgroundQuestions.BrokerFeeRate.fields : ["brokerFeeRate", "isCombineOriginationFee"]);
    }
    else if (step.id === OverviewSteps.Zip.id && gmrObject[OverviewQuestions.Zip.field] && gmrObject[OverviewQuestions.Zip.field].length < 5) {
      notValidProps.push("custom-zip-projectZipCode");
    }
    else if (step.id === ProjectSteps.Properties.id && (!gmrObject[ProjectQuestions.Properties.field] || gmrObject[ProjectQuestions.Properties.field] > 100)) {
      notValidProps.push("numberOfPropertiesOrUnits");
    }
    else if (step.id === ProjectSteps.MonthOfFirstDraw.id) {
      const invaidNestedProps = validateNestedObj(gmrObject[ProjectQuestions.MonthOfFirstDraw.field], "gmrUnitDrawMonths", ["monthOfFirstDraw"]);
      notValidProps = notValidProps.concat(invaidNestedProps);
    }
    else if (step.id === FinancingSteps.CostsPaid.id) {
      const invaidNestedProps = validateNestedObj(gmrObject[FinancingQuestions.CostsPaid.field], "gmrCostPaids", ["gmrprojectCostId", "amount"]);
      notValidProps = notValidProps.concat(invaidNestedProps);
    }
    else if (step.id === BackgroundSteps.BorrowerSelection.id) {
      if (gmrObject.isExistingBorrower) {
        notValidProps = validateObj(gmrObject, ["borrowerOrganizationId"]);
      }
      else if (gmrObject.isExistingBorrower === undefined) {
        notValidProps = notValidProps.concat(["isExistingBorrower"]);
      }
    }
    else if (step.id === BackgroundSteps.BorrowerContact.id) {
      notValidProps = validateObj(newBorrowerEntity, [...BackgroundSteps.BorrowerContact.validatingProps]);
    }

    return notValidProps;
  };

  const formatScenarios = (scenarios) => {
    const newScenarios = [] as any[];
    if (scenarios) {
      scenarios.forEach(scenario => {
        newScenarios.push({
          id: scenario.id,
          name: scenario.name
        });
      });
    }

    return newScenarios;
  };

  const handleRecalculate = async (gmrScenarios) => {
    if (gmrScenarios && gmrScenarios.length > 0) {
      setIsLoading(true);
      if (isRecalculateValid) {
        await handleRecalculateAsync(gmrScenarios);
        setIsRecalculateValid(false);
      }

      setScenarioModal(false);
      setIsLoading(false);
    }
  };

  const handleScenarioModalChange = (value, field, obj, setObj, type = "string", handleCustomFormChange = undefined as any, charLimit = undefined as number | undefined) => {
    handleFormChange(value, field, obj, setObj, type, handleCustomFormChange, charLimit);
  };

  const handleScenarioModalExportComparison = async () => {
    setIsLoading(true);
    handleScenarioModalClose();
    const scenariosToExport = [] as any[];
    let isSuccess = true;
    if (isRecalculateValid) {
      isSuccess = await handleRecalculateAsync(gmrScenarios);
      setIsRecalculateValid(false);
    }

    if (scenarioModalObj.isScenarioOriginal) {
      scenariosToExport.push(gmrObject);
    }

    if (scenarioModalObj.isScenario1 && gmrScenarios[0]) {
      scenariosToExport.push(gmrScenarios[0]);
    }

    if (scenarioModalObj.isScenario2 && gmrScenarios[1]) {
      scenariosToExport.push(gmrScenarios[1]);
    }

    if (isSuccess) {
      await handleExportComparisonAsync(scenariosToExport);
    }

    setIsLoading(false);
  };

  const handleScenarioModalExportIndividually = async () => {
    setIsLoading(true);
    handleScenarioModalClose();
    let isSuccess = true;
    if (gmrScenarios && gmrScenarios.length > 0 && isRecalculateValid) {
      isSuccess = await handleRecalculateAsync(gmrScenarios);
      setIsRecalculateValid(false);
    }

    if (scenarioModalObj.isScenarioOriginal && isSuccess) {
      await handleExportIndividualAsync(gmrObject.id, ScenarioExportNames.original);
    }

    if (scenarioModalObj.isScenario1 && gmrScenarios[0] && isSuccess) {
      await handleExportIndividualAsync(gmrScenarios[0].id, ScenarioExportNames.scenario1);
    }

    if (scenarioModalObj.isScenario2 && gmrScenarios[1] && isSuccess) {
      await handleExportIndividualAsync(gmrScenarios[1].id, ScenarioExportNames.scenario2);
    }

    setIsLoading(false);
  };

  const handleExportComparisonDisabled = () => {
    let scnearioCount = 0;
    if (scenarioModalObj.isScenarioOriginal) {
      scnearioCount++;
    }

    if (scenarioModalObj.isScenario1 && gmrScenarios[0]) {
      scnearioCount++;
    }

    if (scenarioModalObj.isScenario2 && gmrScenarios[1]) {
      scnearioCount++;
    }

    if (scenarioModalObj.isScenario3 && gmrScenarios[2]) {
      scnearioCount++;
    }

    return scnearioCount > 1 ? false : true;
  };

  const handleScenarioModalClose = () => {
    setIsScenarioExportModal(false);
    setScenarioModalObj({});
  };

  const handleExportOnClick = async () => {
    if (gmrScenarios && gmrScenarios.length > 0) {
      setIsScenarioExportModal(true);
    }
    else {
      setIsLoading(true);
      await handleExportIndividualAsync(gmrObject.id, ScenarioExportNames.original);
      setIsLoading(false);
    }
  };

  const handleGenerateScenarioInputArray = () => {
    let allScenarios = [] as any[];
    if (gmrObject.scenarios) {
      allScenarios = gmrObject.scenarios;
      allScenarios.forEach(scenario => {
        const foundScenario = gmrScenarios.find(x => x.id === scenario.id);
        if (foundScenario) {
          scenario.name = foundScenario.name;
        }
      });
    }

    return allScenarios;
  };

  const handleAddScenario = () => {
    const newGmrId = guid();
    const scenarioNumber = gmrObject.scenarios.length;
    if (gmrObject.scenarios && scenarioNumber <= 2) {
      const newName = "New Scenario " + scenarioNumber;
      gmrObject.scenarios.push({ gmrId: newGmrId, name: newName });
      const newGmrObj = deepCopy(gmrObject);
      newGmrObj.sortOrder = scenarioNumber;
      newGmrObj.name = newName;
      newGmrObj.id = newGmrId;
      newGmrObj.stringId = newGmrId;
      newGmrObj.ltv = undefined;
      newGmrObj.ltc = undefined;
      newGmrObj.interestRate = undefined;
      newGmrObj.originationFeeRate = undefined;
      newGmrObj.loanTermInMonths = undefined;
      newGmrObj.wipatClosing = undefined;
      newGmrObj.requiredCashDown = undefined;
      newGmrObj.estimatedClosingDate = undefined;
      newGmrObj.estimatedMaturityDate = undefined;
      if (newGmrObj.gmrUnitDrawMonths && newGmrObj.gmrUnitDrawMonths.length > 0) {
        newGmrObj.gmrUnitDrawMonths.forEach(gmrUnitDrawMonth => {
          const newGmrUnitDrawMonthId = guid();
          gmrUnitDrawMonth.id = newGmrUnitDrawMonthId;
          gmrUnitDrawMonth.stringId = newGmrUnitDrawMonthId;
          gmrUnitDrawMonth.gmrid = newGmrId;
        });
      }

      if (newGmrObj.gmrCostPaids && newGmrObj.gmrCostPaids.length > 0) {
        newGmrObj.gmrCostPaids.forEach(gmrCostPaid => {
          const newGmrCostPaidId = guid();
          gmrCostPaid.id = newGmrCostPaidId;
          gmrCostPaid.stringId = newGmrCostPaidId;
          gmrCostPaid.gmrid = newGmrId;
        });
      }
      
      newGmrObj.isBrokerInvolved = isAdminBrmOrLo;
      gmrScenarios.push(newGmrObj);
      setGmrObject({ ...gmrObject });
      setGmrScenarios([...gmrScenarios]);
      setIsRecalculateValid(true);
    }
    else {
      setScenarioMessage(defaultScenarioMessage);
    }
  };

  const handleEnterKeyNext = (e, currentStepId) => {
    if (!FeatureFlags.IS_BETA) {
      if (e.keyCode === 13 && currentStepId === BackgroundSteps.BrokerFeeRate.id) {
        handleCalculate();
      }
      else if (e.keyCode === 13 && currentStepId !== GetMyRateSteps.Calculation.id) {
        handleTryNext();
      }
    }

    if (FeatureFlags.IS_BETA) {
      const isBrokerFeeScreen = e.keyCode === 13 && currentStepId === BackgroundSteps.BrokerFeeRate.id && isBrokerSearchFocus;
      if (e.keyCode === 13 && currentStepId === BackgroundSteps.BorrowerContact.id) {
        handleCalculate();
      }
      else if (e.keyCode === 13 && currentStepId === BackgroundSteps.BrokerFeeRate.id) {
        if (!(isNewBrokerCreated || selectedBrokerEmail)) {
          handleNewBrokerModal();
        }
        else if (isBrokerModalOpen) {
          handleOpenBrokerageListModal();
        }
        else if (isBrokerageNameModalOpen) {
          handleOpenBrokerageInfoModal();
        }
        else if (isBrokerageInfoModalOpen) {
          handleBrokerModalSubmit();
        }
      }
      else if (e.keyCode === 13 && currentStepId !== GetMyRateSteps.Calculation.id && !isBrokerFeeScreen) {
        handleTryNext();
      }
    }
  };

  const handleTryNext = async (stepId = undefined) => {
    handlePaging();
    const currentStepIndex = ApplicationSteps.findIndex(x => x.id === currentStepId);
    const currentStepItem = ApplicationSteps.find(x => x.id === currentStepId);
    const notValidProps = handleValidation(currentStepItem);
    if (notValidProps.length === 0 && currentStepId !== GetMyRateSteps.Calculation.id) {
      await handleNext(currentStepIndex, stepId);
    }
    else {
      setTimeout(() => {
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleNext = async (currentStepIndex, stepId = undefined) => {
    let nextStepIndex = currentStepIndex + 1;
    if (stepId) {
      const specifiedStepIndex = ApplicationSteps.findIndex(x => x.id === stepId);
      nextStepIndex = specifiedStepIndex;
    }

    let currentExcludedStepIds = excludedStepIds;
    if (ApplicationSteps[currentStepIndex].customNext) {
      currentExcludedStepIds = await handleCustomNext(ApplicationSteps[currentStepIndex].id);
    }

    while (ApplicationSteps[nextStepIndex] && currentExcludedStepIds.includes(ApplicationSteps[nextStepIndex].id)) {
      nextStepIndex++;
    }

    setCurrentStepId(ApplicationSteps[nextStepIndex].id);
    if (nextStepIndex > furthestStepIndex) {
      setFurthestStepIndex(nextStepIndex);
    }

    handleProgress(nextStepIndex);
  };

  const convertToCalculateObject = (gmrObject) => {
    const publishObject = deepCopy(gmrObject);
    if (FeatureFlags.IS_BROKER_FEE_ALLIANCE) {
      publishObject.brokerFeeRate = gmrObject.brokerFeeRate ? Number(gmrObject.brokerFeeRate) : null;
      publishObject.wlbrokerFeeRate = gmrObject.wlbrokerFeeRate ? Number(gmrObject.wlbrokerFeeRate) : null;
    }
    else {
      if (gmrObject.isCombineOriginationFee) {
        if (gmrObject.brokerFeeRate && gmrObject.brokerFeeRate > 1.5) {
          publishObject.wlBrokerFeeRate = 1.5;
          publishObject.brokerFeeRate = Number((Number(gmrObject.brokerFeeRate) - 1.5).toFixed(3));
        }
        else {
          publishObject.wlBrokerFeeRate = gmrObject.brokerFeeRate;
          publishObject.brokerFeeRate = 0;
        }
      }
      else {
        publishObject.wlBrokerFeeRate = 0;
        publishObject.brokerFeeRate = gmrObject.brokerFeeRate ? Number(gmrObject.brokerFeeRate) : null;
      }
    }

    publishObject.cityName = gmrObject.cityName ? gmrObject.cityName : null;
    publishObject.interestRate = gmrObject.interestRate ? gmrObject.interestRate / 100 : null;
    publishObject.originationFeeRate = gmrObject.originationFeeRate ? gmrObject.originationFeeRate / 100 : null;
    publishObject.brokerOrganizationContactId = persona === Personas.BROKER && proxyUser.organizationContactId ? 
      proxyUser.organizationContactId : persona === Personas.BROKER ? user.organizationContactId : gmrObject.brokerOrganizationContactId;

    // TODO: Silent release only
    if (FeatureFlags.IS_BETA && !isAnonymous) {
      if (!publishObject.isExistingBorrower) {
        publishObject.borrowerOrganizationId = guid();
      }

      const borrowerObject = {
        id: publishObject.borrowerOrganizationId,
        companyName: newBorrowerEntity.name,
        entitySubTypeId: newBorrowerEntity.entitySubTypeId,
        street: newBorrowerEntity.physicalStreet,
        cityName: newBorrowerEntity.physicalCityName,
        stateName: newBorrowerEntity.physicalStateName,
        countyName: newBorrowerEntity.physicalCountyName,
        zip: newBorrowerEntity.physicalZipCode,
      };

      delete publishObject.borrowerCompanyName;
      delete publishObject.borrowerEntitySubTypeId;
      delete publishObject.borrowerStreet;
      delete publishObject.borrowerCityName;
      delete publishObject.borrowerStateName;
      delete publishObject.borrowerCountyName;
      delete publishObject.borrowerZip;
      publishObject.borrowerInfo = borrowerObject;
    }
    else if (isAnonymous) {
      publishObject.borrower = publishObject.borrowerCompanyName;
      publishObject.entitySubTypeId = publishObject.borrowerEntitySubTypeId;
      delete publishObject.borrowerCompanyName;
      delete publishObject.borrowerEntitySubTypeId;
    }

    return publishObject;
  };

  const handleCalculateAnonymous = async () => {
    const currentStepItem = ApplicationSteps.find(x => x.id === currentStepId);
    const notValidProps = handleValidation(currentStepItem);
    if (notValidProps.length === 0) {
      setIsLoading(true);
      const publishObject = convertToCalculateObject(gmrObject);
      await handleCalculateAnonymousAsync(publishObject);
      handleTryNext();
      setIsLoading(false);
    }
    else {
      setTimeout(() => {
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleCalculate = async () => {
    const currentStepItem = ApplicationSteps.find(x => x.id === currentStepId);
    const notValidProps = handleValidation(currentStepItem);
    if (notValidProps.length === 0) {
      setInvalidProps([]);
      setIsLoading(true);
      const publishObject = convertToCalculateObject(gmrObject);
      await handleCalculateAsync(publishObject);
      setIsLoading(false);
    }
    else {
      setTimeout(() => {
        setInvalidProps(notValidProps);
      }, 50);
    }
  };

  const handleSubmitAnonymous = async () => {
    setIsLoading(true);
    const isSubmitAnonymousSuccess = await handleSubmitAnonymousGmr();
    if (isSubmitAnonymousSuccess) {
      setIsSubmitAnonymousModal(true);
    }

    setIsLoading(false);
  };

  const handleSubmitAnonymousGmr = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await submitMockAnonymousGmr(gmrObject) : await submitAnonymousGmr(gmrObject, proxyUser.id);
      if (response && response.ok) {
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    return false;
  };

  const handleCalculateAnonymousAsync = async (publishObject) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await calculateMockGMR(publishObject) : await calculateGMR(publishObject, proxyUser.id, isAnonymous);
      if (response && response.ok) {
        const calculateResponse = await response.json();
        const formattedGmrObject = formatGmrSummaryResponse(calculateResponse);
        formattedGmrObject.borrowerCompanyName = gmrObject.borrowerCompanyName;
        formattedGmrObject.borrowerEntitySubTypeId = gmrObject.borrowerEntitySubTypeId;
        formattedGmrObject.firstName = gmrObject.firstName;
        formattedGmrObject.lastName = gmrObject.lastName;
        formattedGmrObject.preferredContactMethodOption = gmrObject.preferredContactMethodOption;
        formattedGmrObject.email = gmrObject.email;
        formattedGmrObject.phone = gmrObject.phone;
        formattedGmrObject.loanOfficerOrganizationContactId = gmrObject.loanOfficerOrganizationContactId;
        setGmrObject(formattedGmrObject);
        setGmrCalculationObject(formattedGmrObject);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    setIsLoading(false);
  };

  const handleCalculateAsync = async (publishObject) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await calculateMockGMR(publishObject) : await calculateGMR(publishObject, proxyUser.id);
      if (response && response.ok) {
        const apiResponse = await response.json();
        await getGmrSummaryAsync(apiResponse.id);
        await handleAssociatedBorrowers(
          isAllBorrowersPersona, 
          handleAssociatedOrganizationContactId(gmrObject, persona === Personas.BROKER && user.organizationContactId),
          setAssociatedBorrowers,
          proxyUser,
          setIsMessage,
          setErrorResponse
        );

        if (isAdminBrmOrLo) {
          const allBrokers = await getAllBrokersAsync();
          gmrMetadata.associatedBrokers = allBrokers;
          setGmrMetadata(gmrMetadata);
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    setIsLoading(false);
  };

  const handleRecalculateAsync = async (gmrScenarios) => {
    const publishScenarios = gmrScenarios.map(gmrScenario => {
      const publishScenario = deepCopy(gmrScenario);
      publishScenario.brokerFeeRate = gmrScenario.brokerFeeRate ? Number(gmrScenario.brokerFeeRate) : null;
      publishScenario.wlbrokerFeeRate = gmrScenario.wlbrokerFeeRate ? Number(gmrScenario.wlbrokerFeeRate) : null;
      publishScenario.interestRate = gmrScenario.interestRate ? gmrScenario.interestRate / 100 : null;
      publishScenario.originationFeeRate = gmrScenario.originationFeeRate ? gmrScenario.originationFeeRate / 100 : null;
      delete publishScenario.cityId;
      delete publishScenario.stateId;
      delete publishScenario.countyId;
      return publishScenario;
    });

    try {
      const response = FeatureFlags.IS_MOCK ? await calculateMockGMR(publishScenarios) : await recalculateGMR(publishScenarios, proxyUser.id);
      if (response && response.ok) {
        const scenarios = await response.json();
        const failedSceanrios = scenarios.filter(x => x.isCalculationSuccess === false);
        setGmrScenarios([...scenarios]);
        if (failedSceanrios.length === 0) {
          await getGmrSummaryAsync(pricingId);
          return true;
        }

        setScenarioMessage(defaultScenarioMessage);
        return false;
      }
    }
    catch (error) {
      setScenarioMessage(defaultScenarioMessage);
    }

    return false;
  };

  const handleExportComparisonAsync = async (scenarios) => {
    const formattedScenarios = formatScenarios(scenarios);
    try {
      const response = FeatureFlags.IS_MOCK ? await exportMockGMRQuotes(formattedScenarios) : await exportGMRQuotes(formattedScenarios, proxyUser.id);
      if (response && response.ok) {
        const data = await response.blob();
        const exportQuote = await createFile(data, "gmr-quote", data.type);
        setExportURL(URL.createObjectURL(exportQuote));
        if (exportRef.current) {
          exportRef.current.click();
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }
  };

  const handleExportIndividualAsync = async (scenarioId, scenarioToExport) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await exportMockGMRQuote(scenarioId) : await exportGMRQuote(scenarioId, proxyUser.id);
      if (response && response.ok) {
        const data = await response.blob();
        const exportQuote = await createFile(data, "gmr-quote", data.type);
        if (scenarioToExport === ScenarioExportNames.original) {
          setOriginalScenarioURL(URL.createObjectURL(exportQuote));
          if (originalScenarioRef.current) {
            originalScenarioRef.current.click();
          }
        }
        else if (scenarioToExport === ScenarioExportNames.scenario1) {
          setScenario1URL(URL.createObjectURL(exportQuote));
          if (scenario1Ref.current) {
            scenario1Ref.current.click();
          }
        }
        else if (scenarioToExport === ScenarioExportNames.scenario2) {
          setScenario2URL(URL.createObjectURL(exportQuote));
          if (scenario2Ref.current) {
            scenario2Ref.current.click();
          }
        }
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    setExportLoading(false);
  };

  const handleReciepients = (value) => {
    setSelectedRecipients([...selectedRecipients, value]);
  };

  const handleRemoveReciepient = (i) => {
    const ccReciepients = [...selectedRecipients];
    ccReciepients.splice(i, 1);
    setSelectedRecipients(ccReciepients);
  };

  const handleIsShowButton = () => {
    if (isAdminPersona && currentStepId === GetMyRateSteps.Calculation.id && !FeatureFlags.IS_BETA) {
      return false;
    }
    else if (isStartApplicationPersona || isAnonymous) {
      return true;
    }
    
    return false;
  };

  const formatGmrSummaryResponse = (gmrSummary) => {
    if (gmrSummary.gmrUnitDrawMonths && gmrSummary.gmrUnitDrawMonths.length > 1) {
      gmrSummary.gmrUnitDrawMonths.sort((a, b) => {
        return a.unitNo - b.unitNo;
      });
    }

    gmrSummary[FinancingQuestions.HasPaidCosts.field] = (gmrSummary[FinancingQuestions.CostsPaid.field] && gmrSummary[FinancingQuestions.CostsPaid.field].length > 0) ? true : false;
    gmrSummary.interestRate = gmrSummary.interestRate ? roundNumber(gmrSummary.interestRate * 100) : undefined;
    gmrSummary.originationFeeRate = gmrSummary.originationFeeRate ? roundNumber(gmrSummary.originationFeeRate * 100) : undefined;
    gmrSummary.estimatedClosingDate = gmrSummary.estimatedClosingDate ? convertToDateString(new Date(gmrSummary.estimatedClosingDate)) : undefined;
    gmrSummary.estimatedMaturityDate = gmrSummary.estimatedMaturityDate ? convertToDateString(new Date(gmrSummary.estimatedMaturityDate)) : undefined;
    gmrSummary.ltv = gmrSummary.ltv ? roundNumber(gmrSummary.ltv * 100) : undefined;
    gmrSummary.ltc = gmrSummary.ltc ? roundNumber(gmrSummary.ltc * 100) : undefined;
    gmrSummary.cityName = (gmrSummary.cityName && gmrSummary.cityName === "Unknown") ? null : gmrSummary.cityName;

    if (FeatureFlags.IS_BROKER_FEE_ALLIANCE) {
      gmrSummary.brokerFeeRate = gmrSummary.brokerFeeRate ? roundNumber(gmrSummary.brokerFeeRate) : undefined;
      gmrSummary.wlbrokerFeeRate = gmrSummary.wlbrokerFeeRate ? roundNumber(gmrSummary.wlbrokerFeeRate) : undefined;
    }
    else {
      if (gmrSummary?.wlbrokerFeeRate > 0) {
        let displayBrokerFeeRate = gmrSummary.wlbrokerFeeRate;
        if (gmrSummary?.brokerFeeRate > 0) {
          displayBrokerFeeRate = displayBrokerFeeRate + gmrSummary.brokerFeeRate;
        }

        gmrSummary.brokerFeeRate = displayBrokerFeeRate;
        gmrSummary.isCombineOriginationFee = true;
      } 
      else if (gmrSummary?.wlbrokerFeeRate || gmrSummary?.brokerFeeRate) {
        gmrSummary.brokerFeeRate = gmrSummary.brokerFeeRate ? roundNumber(gmrSummary.brokerFeeRate) : undefined;
        gmrSummary.wlbrokerFeeRate = 0;
        gmrSummary.isCombineOriginationFee = false;
      }
    }

    // TODO: Silent release only
    if (FeatureFlags.IS_BETA) {
      if (gmrSummary.borrowerInfo) {
        newBorrowerEntity.name = gmrSummary.borrowerInfo.companyName;
        newBorrowerEntity.entitySubTypeId = gmrSummary.borrowerInfo.entitySubTypeId;
        newBorrowerEntity.physicalStreet = gmrSummary.borrowerInfo.street;
        newBorrowerEntity.physicalCityName = gmrSummary.borrowerInfo.cityName;
        newBorrowerEntity.physicalStateName = gmrSummary.borrowerInfo.stateName;
        newBorrowerEntity.physicalCountyName = gmrSummary.borrowerInfo.countyName;
        newBorrowerEntity.physicalZipCode = gmrSummary.borrowerInfo.zip;
        gmrSummary.isExistingBorrower = true;
      }

      if (isAdminBrmOrLo && gmrSummary.brokerOrganizationContactId && gmrSummary.brokerEmail) {
        gmrSummary.isBrokerInvolved = true;
        gmrSummary.brokerSearchEmail = gmrSummary.brokerEmail;
        setBrokerSearch(gmrSummary.brokerEmail);
      }
      else if (isAdminBrmOrLo && !gmrSummary.brokerOrganizationContactId) {
        gmrSummary.isBrokerInvolved = false;
      }
    }

    return gmrSummary;
  };

  const getGmrScenariosAsync = async (scenariosNameIds) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockGmrScenarios(scenariosNameIds) : await getGmrScenarios(scenariosNameIds, proxyUser.id);
      if (response && response.ok) {
        const scenarioResponses = await response.json();
        const gmrScenarios = [] as any[];
        scenarioResponses.forEach(scenarioResponse => {
          gmrScenarios.push(formatGmrSummaryResponse(scenarioResponse));
        });

        return gmrScenarios;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    return [];
  };

  const formatGmrScenarios = (gmrObject, scenarios) => {
    const formattedScenarios = [] as any[];
    scenarios.forEach(scenario => {
      if (!scenario.isBrokerInvolved) {
        scenario.isBrokerInvolved = gmrObject.isBrokerInvolved;
      }
      
      if (!scenario.loanOfficerOrganizationContactId) {
        scenario.loanOfficerOrganizationContactId = gmrObject.loanOfficerOrganizationContactId;
      }

      if (!scenario.borrowerOrganizationId) {
        scenario.borrowerOrganizationId = gmrObject.borrowerOrganizationId;
      }

      if (!scenario.borrowerEntitySubTypeId) {
        if (gmrObject.borrowerInfo) {
          scenario.borrowerEntitySubTypeId = gmrObject.borrowerInfo.entitySubTypeId;
        }
        else {
          scenario.borrowerEntitySubTypeId = gmrObject.borrowerEntitySubTypeId;
        }
      }

      formattedScenarios.push(scenario);
    });

    return formattedScenarios;
  };

  const getGmrSummaryAsync = async (pricingId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockGMRSummary(pricingId) : await getGMRSummary(pricingId, proxyUser.id);
      if (response && response.ok) {
        const gmrSummaryObject = await response.json();
        let gmrScenarioResponses = [] as any[];
        const gmrScenarios = gmrSummaryObject.scenarios.filter(x => x.id !== pricingId);
        if (gmrScenarios.length > 0) {
          const gmrScenarioIdPairs = [] as any[];
          gmrScenarios.forEach(gmrScenario => {
            gmrScenarioIdPairs.push({
              id: gmrScenario.id,
              name: gmrScenario.name
            });
          });

          gmrScenarioResponses = await getGmrScenariosAsync(gmrScenarioIdPairs);
        }

        const formattedGmrObject = formatGmrSummaryResponse(gmrSummaryObject);
        setGmrObject(formattedGmrObject);
        setGmrCalculationObject(formattedGmrObject);
        setGmrScenarios(formatGmrScenarios(gmrSummaryObject, gmrScenarioResponses));
        handleTryNext();
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }
  };

  const sendEmailToBrokerAsync = async (brokerEmailObj) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await sendMockEmailToBroker(brokerEmailObj) : await sendEmailToBroker(brokerEmailObj, proxyUser.id);
      if (response && response.ok) {
        setIsBrokerInvited(true);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }
  };

  const getGmrEmployeesMetadataAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockGmrEmployeesMetadata() : await getInternalContacts(proxyUser.id);
      if (response && response.ok) {
        const internalEmployeeList = await response.json();
        setInternalEmployees(internalEmployeeList);
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }
  };

  const handleGetBorrowerEntityAsync = async (entityId) => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockBorrowerEntity(undefined, entityId) : await getBorrowerEntity(undefined, entityId, proxyUser.id) as any;
      if (response && response.ok) {        
        const apiBorrower = await response.json();
        newBorrowerEntity.name = apiBorrower.name;
        newBorrowerEntity.entitySubTypeId = apiBorrower.entitySubTypeId;
        newBorrowerEntity.physicalStreet =  apiBorrower.physicalStreet;
        newBorrowerEntity.physicalCityName = apiBorrower.physicalCityName;
        newBorrowerEntity.physicalStateName = apiBorrower.physicalStateName;
        newBorrowerEntity.physicalCountyName = apiBorrower.physicalCountyName;
        newBorrowerEntity.physicalZipCode = apiBorrower.physicalZipCode;
        setGmrObject({ ...gmrObject });
        return true;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      setIsMessage(false);
    }

    return false;
  };

  const getAllBrokersAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockAllBrokers() : await getAllBrokers(proxyUser.id);
      if (response && response.ok) {
        const allBrokers = await response.json();
        return allBrokers;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }
  };

  useEffect(() => {
    const getGmrInfoListAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockGMRInfolist() : await getGMRInfoList(proxyUser.id);
        if (response && response.ok) {
          return await response.json();
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }
    };

    const getGmrMetadataAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockGMRMetadata() : await getGMRMetadata(proxyUser.id);
        if (response && response.ok) {
          const metadata = await response.json();
          let allBrokers = [];
          if (isAdminBrmOrLo) {
            allBrokers = await getAllBrokersAsync();
            metadata.associatedBrokers = allBrokers;
          }

          setGmrMetadata(metadata);
          await handleUserIsLoanOfficer(metadata, user);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }
    };

    const handleCopyGMR = async (gmrSummaryObject, newGmrId = undefined) => {
      setFurthestStepIndex(ApplicationSteps.findIndex(x => x.id === GetMyRateSteps.Calculation.id));
      gmrSummaryObject.id = newGmrId;
      gmrSummaryObject.masterGmrid = undefined;
      gmrSummaryObject.stringId = undefined;
      gmrSummaryObject.submittedOn = undefined;
      if (gmrSummaryObject.gmrUnitDrawMonths && gmrSummaryObject.gmrUnitDrawMonths.length > 0) {
        gmrSummaryObject.gmrUnitDrawMonths.forEach(gmrUnitDrawMonth => {
          const newGmrUnitDrawMonthId = guid();
          gmrUnitDrawMonth.id = newGmrUnitDrawMonthId;
          gmrUnitDrawMonth.stringId = newGmrUnitDrawMonthId;
          gmrUnitDrawMonth.gmrid = newGmrId;
        });
      }

      if (gmrSummaryObject.gmrCostPaids && gmrSummaryObject.gmrCostPaids.length > 0) {
        gmrSummaryObject.gmrCostPaids.forEach(gmrCostPaid => {
          const newGmrCostPaidId = guid();
          gmrCostPaid.id = newGmrCostPaidId;
          gmrCostPaid.stringId = newGmrCostPaidId;
          gmrCostPaid.gmrid = newGmrId;
        });
      }
    };

    const getGmrScenariosAsync = async (scenariosNameIds) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockGmrScenarios(scenariosNameIds) : await getGmrScenarios(scenariosNameIds, proxyUser.id);
        if (response && response.ok) {
          const scenarioResponses = await response.json();
          scenarioResponses.sort((a, b) => {
            return a.sortOrder - b.sortOrder;
          });

          const gmrScenarios = [] as any[];
          let scenarioLimit = 2;
          scenarioResponses.forEach(scenarioResponse => {
            if (scenarioLimit > 0) {
              gmrScenarios.push(formatGmrSummaryResponse(scenarioResponse));
              scenarioLimit--;
            }
          });

          return gmrScenarios;
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }

      return [];
    };

    const getGmrSummaryAsync = async (pricingId, newGmrId = undefined) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockGMRSummary(pricingId) : await getGMRSummary(pricingId, proxyUser.id);
        if (response && response.ok) {
          const gmrSummaryObject = await response.json();
          let gmrScenarioResponses = [] as any[];
          const gmrScenarios = gmrSummaryObject.scenarios.filter(x => x.id !== pricingId);
          let scenarioLimit = 2;
          if (gmrScenarios.length > 0) {
            gmrScenarios.sort((a, b) => {
              return a.sortOrder - b.sortOrder;
            });

            const gmrScenarioIdPairs = [] as any[];
            gmrScenarios.forEach(gmrScenario => {
              if (scenarioLimit > 0) {
                gmrScenarioIdPairs.push({
                  id: gmrScenario.id,
                  name: gmrScenario.name
                });

                scenarioLimit--;
              }
            });

            gmrScenarioResponses = await getGmrScenariosAsync(gmrScenarioIdPairs);
          }

          if (newGmrId) {
            handleCopyGMR(gmrSummaryObject, newGmrId);
          }

          await handleAssociatedBorrowers(
            isAllBorrowersPersona, 
            handleAssociatedOrganizationContactId(gmrSummaryObject, persona === Personas.BROKER && user.organizationContactId),
            setAssociatedBorrowers,
            proxyUser,
            setIsMessage,
            setErrorResponse
          );

          setGmrObject(formatGmrSummaryResponse(gmrSummaryObject));
          setGmrScenarios(formatGmrScenarios(gmrSummaryObject, gmrScenarioResponses));
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }
    };

    const getGmrAnonymousMetadataAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockGMRMetadata() : await getGMRMetadata(proxyUser.id, isAnonymous);
        if (response && response.ok) {
          const metadata = await response.json();
          setGmrMetadata(metadata);
          handleUserIsLoanOfficer(metadata, user);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        setIsMessage(false);
      }
    };

    const handleExcludedIds = () => {
      let currentExcludedIds = [] as any[];
      if (isAnonymous) {
        currentExcludedIds = currentExcludedIds.concat([BackgroundSteps.BrokerFeeRate.id, BackgroundSteps.BorrowerSelection.id, BackgroundSteps.BorrowerContact.id]);
      }
      else {
        currentExcludedIds = currentExcludedIds.concat([BackgroundSteps.ContactInformation.id, BackgroundSteps.BorrowerEntity.id]);
        if (!FeatureFlags.IS_BETA) {
          currentExcludedIds = currentExcludedIds.concat([BackgroundSteps.BorrowerSelection.id, BackgroundSteps.BorrowerContact.id]);
        }
      }

      setExcludedStepIds(currentExcludedIds);
    };

    const getAllDataAsync = async (pricingId) => {
      try {
        if (isAnonymous) {
          await getGmrAnonymousMetadataAsync();
          gmrObject.id = pricingId;
          setGmrObject({ ...gmrObject });
        }
        else {
          await getGmrMetadataAsync();
          const gmrInfoList = await getGmrInfoListAsync();
          setGmrObject({
            ...gmrObject,
            id: pricingId, 
            gmrCostPaids: [{
              amount: undefined,
              gmrprojectCostId: undefined,
              name: undefined
            }],
            isBrokerInvolved: isAdminBrmOrLo ? false : undefined
          } as IGmrObject);

          if (gmrInfoList && gmrInfoList.length > 0) {
            const foundGmrInfo = gmrInfoList.find(x => x.id === pricingId.toLocaleLowerCase());
            if (foundGmrInfo) {
              await getGmrSummaryAsync(pricingId);
            }
            else if (copiedGmrId !== undefined) {
              await getGmrSummaryAsync(copiedGmrId, pricingId);
            }
            else {
              await handleAssociatedBorrowers(
                isAllBorrowersPersona, 
                null,
                setAssociatedBorrowers,
                proxyUser,
                setIsMessage,
                setErrorResponse
              );
            }
          }
        }

        handleExcludedIds();
        setIsLoading(false);
      }
      catch (error) {
        setIsLoading(false);
      }
    };

    if (isFirstLoad) {
      // TODO: Temporary silent release route handling
      if (!FeatureFlags.IS_BETA && !gmrId) {
        handleRouteToHome();
      }

      if (getIsWhiteLabeled()) {
        handleRouteToApplications();
      }

      if (gmrRef.current) {
        gmrRef.current.focus();
      }

      if (isPricingStartScenarios) {
        setScenarioModal(false);
        setCurrentStepId(GetMyRateSteps.Calculation.id);
        const calculationStepIndex = ApplicationSteps.findIndex(x => x.id === GetMyRateSteps.Calculation.id);
        setFurthestStepIndex(calculationStepIndex);
        handleProgress(calculationStepIndex);
        setIsPricingStartScenarios(false);
      }

      getAllDataAsync(pricingId);
    }
  }, [
    setIsMessage,
    setErrorResponse,
    handleError,
    proxyUser,
    isFirstLoad,
    pricingId,
    FinancingQuestions,
    BackgroundQuestions,
    gmrObject,
    ApplicationSteps,
    GetMyRateSteps,
    copiedGmrId,
    gmrScenarios,
    handleRouteToApplications,
    isPricingStartScenarios,
    setIsPricingStartScenarios,
    GetMyRateSteps.Calculation.id
  ]);

  useEffect(() => {
    setIsFirstLoad(false);
  }, []);

  return (
    <div
      className={`wizard-container ${(isGreaterThanTablet && isSidebar) ? "hide-sidebar" : "sidebar"}`}
      tabIndex={0}
      onKeyDown={(e) => handleEnterKeyNext(e, currentStepId)}
      ref={gmrRef as any}
    >
      <BCMessage
        animation={"fly down"}
        duration={750}
        visible={isMessage}
        transitionOnMount
        styles="full-width"
        onDismiss={() => setIsMessage(false)}
        errorResponse={errorResponse}
      />
      <BCMessage
        animation={"fly down"}
        duration={750}
        visible={isNewBrokerCreated}
        transitionOnMount
        styles="full-width"
        color="green"
        onDismiss={() => setIsNewBrokerCreated(false)}
        header={"Success!"}
        text={isAdminBrmOrLo ? "Email invitation has been sent to broker" : "New Broker has been created"}
      />
      <BCMessage
        animation={GlobalConstants.StaticMessage.animation}
        duration={GlobalConstants.StaticMessage.duration}
        visible={isBrokerInvited}
        transitionOnMount
        styles="full-width"
        color="green"
        onDismiss={() => setIsBrokerInvited(false)}
        header="Success!"
        text={successMessage}
      />
      <BCMessage
        animation={"fly down"}
        duration={750}
        visible={scenarioMessage !== ""}
        transitionOnMount
        styles="full-width card-margin"
        negative
        color="red"
        onDismiss={() => setScenarioMessage("")}
        header={"Oops!"}
        text={scenarioMessage}
      />
      <input className="gmr-unfocus-input" ref={unfocusRef as any} />
      {isValidPermission(permissions, "BrokerGMRPricingInfo", "export") && <a className={"export-link"} href={exportURL} download ref={exportRef as any}>0</a>}
      {isValidPermission(permissions, "BrokerGMRPricingInfo", "export") && <a className={"export-link"} href={originalScenarioURL} download ref={originalScenarioRef as any}>1</a>}
      {isValidPermission(permissions, "BrokerGMRPricingInfo", "export") && <a className={"export-link"} href={scenario1URL} download ref={scenario1Ref as any}>2</a>}
      {isValidPermission(permissions, "BrokerGMRPricingInfo", "export") && <a className={"export-link"} href={scenario2URL} download ref={scenario2Ref as any}>3</a>}
      <React.Fragment>
        <BCSteps
          isGreaterThanMobile={isGreaterThanMobile}
          currentProgress={currentProgress}
          handleStep={(step) => handleNavigateToStep(step)}
          steps={ApplicationMainSteps}
        />
        <div className={"application-screen-container"}>
          <Card fluid>
            <Card.Content>
              <Card.Description className="gmr-card">
                {isLoading ? <Loader active inline="centered" size={"big"} /> : <Form className="primary-form" autoComplete="off">
                  <Grid>
                    {ApplicationSteps.map((step, i) => {
                      return (
                        <React.Fragment key={`application-step-${i}`}>
                          {currentStepId === step.id && <React.Fragment>
                            {step.questions.map((question, j) => {
                              return (
                                <React.Fragment key={`application-question-${i}-${j}`}>
                                  {question.content && question.content}
                                </React.Fragment>
                              );
                            })}
                            <Grid.Row className="application-row">
                              {Object.values(GmrWarnings).map((gmrWarning, i) => {
                                return (
                                  <Grid.Column key={`gmr-warning-${i}`} width={16}>
                                    <BCValidationMessage
                                      invalidProps={warningIds}
                                      prop={gmrWarning.id}
                                      propText={gmrWarning.message}
                                      color="yellow"
                                      onDismiss={() => setWarningIds([])}
                                    />
                                  </Grid.Column>
                                );
                              })}
                            </Grid.Row>
                          </React.Fragment>}
                        </React.Fragment>
                      );
                    })}
                  </Grid>
                </Form>}
              </Card.Description>
              <Card.Content extra className="application-extra">
                <BCModal isModalOpen={isScenarioExportModal}
                  size="large"
                  onClose={() => handleScenarioModalClose()}
                  onOpen={() => setIsScenarioExportModal(true)}
                  actions={<Grid>
                    <Grid.Row columns={2}>
                      <Grid.Column>
                        <Button icon fluid onClick={() => handleScenarioModalExportIndividually()}>
                          <div className="gmr-button-container">
                            <div className="gmr-button-text">Export Individually</div>
                          </div>
                        </Button>
                      </Grid.Column>
                      <Grid.Column>
                        <Button
                          className="bp-button"
                          style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
                          fluid
                          onClick={() => handleScenarioModalExportComparison()}
                          disabled={handleExportComparisonDisabled()}
                        >
                          <div className="gmr-button-container">
                            <div className="gmr-button-text">Export Comparison</div>
                          </div>
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>}
                  header="Which would you like to export?"
                  content={<React.Fragment>
                    <BCFormInput
                      labelClass="gmr-background-label"
                      inputKey="pricing-gmrscenario"
                      type="checkbox"
                      checkboxText="Original"
                      obj={scenarioModalObj}
                      field="isScenarioOriginal"
                      value={scenarioModalObj.isScenarioOriginal}
                      handleFormChange={(value, field) => handleScenarioModalChange(value, field, scenarioModalObj, setScenarioModalObj)}
                    />
                    {(gmrScenarios && gmrScenarios.length > 0) && gmrScenarios.map((gmrScenario, i) => {
                      return (
                        <BCFormInput
                          key={`gmrIsScenarioCheckbox-${i}`}
                          inputKey={`pricing-scenario-${i}`}
                          labelClass="gmr-background-label"
                          type="checkbox"
                          checkboxText={gmrScenario.name ? gmrScenario.name : ""}
                          obj={scenarioModalObj}
                          field={`isScenario${i + 1}`}
                          value={scenarioModalObj[`isScenario${i + 1}`]}
                          handleFormChange={(value, field) => handleScenarioModalChange(value, field, scenarioModalObj, setScenarioModalObj)}
                        />
                      );
                    })}
                  </React.Fragment>}
                />
                <BCModal isModalOpen={previousModal}
                  brokerColor="#EED202"
                  size="large"
                  onClose={() => setPreviousModal(false)}
                  onOpen={() => setPreviousModal(true)}
                  actions={<Grid>
                    <Grid.Row columns={2}>
                      <Grid.Column>
                        <Button icon fluid onClick={() => handlePrev()}>
                          <div className="gmr-button-container">
                            <div className="gmr-button-text">Go Back</div>
                          </div>
                        </Button>
                      </Grid.Column>
                      <Grid.Column>
                        <Button
                          className="bp-button"
                          style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
                          fluid
                          onClick={() => setPreviousModal(false)}
                        >
                          <div className="gmr-button-container">
                            <div className="gmr-button-text">Keep me here!</div>
                          </div>
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>}
                  header="Warning, you will lose your data!"
                  content="If you proceed to the previous page, your scenarios will be lost."
                />
                <BCModal 
                  isModalOpen={startApplicationModal}
                  brokerColor={brokerColor}
                  size="large"
                  onClose={() => setStartApplicationModal(false)}
                  onOpen={() => setStartApplicationModal(true)}
                  actions={<Grid>
                    <Grid.Row columns={2}>
                      <Grid.Column>
                        <Button icon fluid onClick={() => setStartApplicationModal(false)}>
                          <div className="gmr-button-container">
                            <div className="gmr-button-text">Go Back</div>
                          </div>
                        </Button>
                      </Grid.Column>
                      <Grid.Column>
                        <Button
                          className="bp-button"
                          style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
                          fluid
                          onClick={() => handleLoanApplication()}
                        >
                          <div className="gmr-button-container">
                            <div className="gmr-button-text">Start Application</div>
                          </div>
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>}
                  header={"Which scenario would you like to start an application with?"}
                  content={<Grid.Row className="application-row">
                    <Grid.Column width={16}>
                      <BCFormInput
                        type="radio"
                        inputArray={handleGenerateScenarioInputArray()}
                        obj={gmrObject}
                        field="chosenScenario"
                        valueField="name"
                        handleFormChange={(value, field) => handleFormChange(value, field, gmrObject, setGmrObject, "string", handleCustomFormChange)}
                      />
                    </Grid.Column>
                  </Grid.Row>}
                />
                <BCModal 
                  isModalOpen={isSubmitAnonymousModal}
                  brokerColor={brokerColor}
                  size="large"
                  onClose={() => setIsSubmitAnonymousModal(false)}
                  onOpen={() => setIsSubmitAnonymousModal(true)}
                  actions={<Grid>
                    <Grid.Row columns={2}>
                      <Grid.Column>
                        <Button icon fluid onClick={() => setIsSubmitAnonymousModal(false)}>
                          <div className="gmr-button-container">
                            <div className="gmr-button-text">Close</div>
                          </div>
                        </Button>
                      </Grid.Column>
                      <Grid.Column>
                        <Button
                          className="bp-button"
                          fluid
                          onClick={() => handleRouteToBorrowerApplication()}
                        >
                          <div className="gmr-button-container">
                            <div className="gmr-button-text">Start Application</div>
                          </div>
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>}
                  header="Next Steps"
                  content={<Grid.Row className="application-row">
                    <Grid.Column width={16}><div>We have received your submission!</div></Grid.Column>
                    <Grid.Column width={16}><div className="gmr-disclaimer">Our Sales Team will be in contact with you shortly to discuss your project and put our innovative, creative structure to work for you.</div></Grid.Column>
                    <Grid.Column width={16}><div className="gmr-disclaimer">If you’re ready to take the next steps and start your application, we will redirect you to our Portal, where you will have 24/7 access to your loan applications, draws and more.</div></Grid.Column>
                  </Grid.Row>}
                />
                <BPNewBrokerModals 
                  newBroker={newBroker}
                  setNewBroker={setNewBroker}
                  newBrokerageName={newBrokerageName}
                  setNewBrokerageName={setNewBrokerageName}
                  brokerageInfo={brokerageInfo}
                  isNewBrokerage={isNewBrokerage}
                  setBrokerageInfo={setBrokerageInfo}
                  isBrokerModalOpen={isBrokerModalOpen}
                  setIsBrokerModalOpen={setIsBrokerModalOpen}
                  isBrokerageNameModalOpen={isBrokerageNameModalOpen}
                  setIsBrokerageNameModalOpen={setIsBrokerageNameModalOpen}
                  isBrokerageInfoModalOpen={isBrokerageInfoModalOpen}
                  setIsBrokerageInfoModalOpen={setIsBrokerageInfoModalOpen}
                  isModalMessage={isModalMessage}
                  setIsModalMessage={setIsModalMessage}
                  errorResponse={errorResponse}
                  metadata={gmrMetadata}
                  handleOpenBrokerageListModal={handleOpenBrokerageListModal}
                  isGreaterThanMobile={isGreaterThanMobile}
                  isModalLoading={isModalLoading}
                  similarBrokerageList={similarBrokerageList}
                  newBrokerageId={newBrokerageId}
                  handleSelectBrokerage={handleSelectBrokerage}
                  handleOpenBrokerageInfoModal={handleOpenBrokerageInfoModal}
                  handleBrokerModalSubmit={handleBrokerModalSubmit}
                  brokerColor={brokerColor}
                  invalidProps={invalidProps}
                />
                {FeatureFlags.IS_BETA && <BCModal
                  isModalOpen={isScenarioSentToBrokerModal}
                  closeOnlyByButton={true}
                  onClose={() => setIsScenarioSentToBrokerModal(false)}
                  onOpen={() => setIsScenarioSentToBrokerModal(true)}
                  header="Send to Broker"
                  subHeader={"Not only can you send the following email to your Broker, but upon clicking \"Send\" below, the pricing card will show up on the Broker's Pricing Dashboard, allowing them to create scenarios."}
                  content={isSendBrokerEmailLoading ? <Loader className="modal-loader" active inline="centered" size={"big"} /> : 
                  <Form className="primary-form">
                    <p>From: {user.email}</p>
                    <p>To: {gmrObject.brokerEmail}</p>
                    <BCFormInput
                      labelClass="gmr-background-label"
                      inputKey="search-recipients"
                      label="Select Recipients to CC:"
                      type={GlobalConstants.FormInputTypes.SEARCH_FILTER}
                      onSearchChange={(value) => handleOnSearchRecipientsChange(value)}
                      value={recipientSearchInput}
                      renderSuggestions={handleFilterRecipientSuggestions(recipientSearchInput)}
                      handleSearchSelect={(e, data) => handleRecipientSelect(data.result)}
                      isSearchOpen={isAddingRecipient}
                      noSearchResultsMessage="To add a recipient, type their name or email and press enter."
                      searchClass="bc-search-input-full"
                      handleSearchKeyDown={handleRecipientSearchKeyDown}
                    />
                    <Grid className="gmr-cc-recipients">
                      <Grid.Row>
                        <Grid.Column width={1}>CC:</Grid.Column>
                        <Grid.Column width={15}>
                          {selectedRecipients.map(recipient => {
                            return (
                              <p key={recipient.id}>{recipient} <Icon name="close" color="red" onClick={() => setSelectedRecipients(selectedRecipients.filter(x => x !== recipient))}/></p>
                            );
                          })}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    <p>Subject: A Pricing has been created for {gmrObject.name}</p>
                    <p>Hi {gmrObject.brokerInfo && gmrObject.brokerInfo.firstName}</p>
                    <p>I have requested Pricing on your behalf for <Link to={`getmyrate/${gmrObject.id}`}>{gmrObject.name}</Link></p>
                    <BCFormInput
                      labelClass="gmr-background-label"
                      type="textarea"
                      label="Would you like to add a comment?"
                      placeholder="Write your comment here..."
                      field="description"
                      value={emailBrokerObj.description}
                      handleFormChange={(value, field) => handleFormChange(value, field, emailBrokerObj, setEmailBrokerObj, "string", handleCustomFormChange, 255)}
                      charLimit={500}
                    />
                    <p>Best,</p>
                    <p>{user.name}</p>
                  </Form>}
                  actions={<Grid>
                    <Grid.Row columns={2}>
                      <Grid.Column>
                        <Button icon fluid onClick={() => setIsScenarioSentToBrokerModal(false)}>
                          <div className="gmr-button-container">
                            <div className="gmr-button-text">Close</div>
                          </div>
                        </Button>
                      </Grid.Column>
                      <Grid.Column>
                        <Button
                          className="bp-button"
                          fluid
                          onClick={() => handleSendToBroker()}
                        >
                          <div className="gmr-button-container">
                            <div className="gmr-button-text">Send</div>
                          </div>
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>}
                />}
                <Grid>
                  <Grid.Row columns={isGreaterThanMobile ? 2 : 1}>
                    <Grid.Column>
                      <Button icon fluid onClick={() => currentStepId === GetMyRateSteps.Calculation.id ? setPreviousModal(true) : handlePrev()}>
                        <div className="primary-wizard-button-container">
                          <Icon name='arrow alternate circle left' size="large" />
                          <div className="gmr-button-icon-text">{"Previous"}</div>
                        </div>
                      </Button>
                    </Grid.Column>
                    <Grid.Column className={isGreaterThanMobile ? "" : "primary-mobile-button-spacing"}>
                      {handleIsShowButton() && <Button
                        className="bp-button"
                        icon
                        fluid
                        onClick={async () =>
                          (currentStepId === GetMyRateSteps.Calculation.id && isAnonymous) ? handleSubmitAnonymous() :
                            (currentStepId === GetMyRateSteps.Calculation.id && gmrScenarios.length > 0) ? setStartApplicationModal(true) :
                              (currentStepId === GetMyRateSteps.Calculation.id && gmrScenarios.length <= 0) ? handleLoanApplication() :
                                (currentStepId === BackgroundSteps.BrokerFeeRate.id && !FeatureFlags.IS_BETA) ||
                                  currentStepId === BackgroundSteps.BorrowerContact.id ? await handleCalculate() :
                                    currentStepId === BackgroundSteps.BorrowerEntity.id ? handleCalculateAnonymous() :
                                      handleTryNext()}
                      >
                        <div className="primary-wizard-button-container">
                          <div className="gmr-button-icon-text">{
                            (currentStepId === GetMyRateSteps.Calculation.id && isAnonymous) ? "Submit" :
                              currentStepId === GetMyRateSteps.Calculation.id ? "Submit and Start Application" :
                                (currentStepId === BackgroundSteps.BrokerFeeRate.id && !FeatureFlags.IS_BETA) ||
                                  currentStepId === BackgroundSteps.BorrowerEntity.id || currentStepId === BackgroundSteps.BorrowerContact.id ? 
                                    "Calculate" : "Next"}</div>
                          <Icon name='arrow alternate circle right' size="large" />
                        </div>
                      </Button>}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Card.Content>
            </Card.Content>
          </Card>
        </div>
      </React.Fragment>
      {FeatureFlags.IS_DEBUG && <React.Fragment>
        <div>Application Step Index: {ApplicationSteps.findIndex(x => x.id === currentStepId)}</div>
        <div>Application Progress: {currentProgress}</div>
        <input onChange={(e) => (ApplicationSteps[parseInt(e.target.value)] && ApplicationSteps[parseInt(e.target.value)].id) ?
          setCurrentStepId(ApplicationSteps[parseInt(e.target.value)].id) : void 0} />
        <button onClick={() => console.log(gmrObject)}>gmrObject</button>
        <button onClick={() => console.log(gmrScenarios)}>gmrScenarios</button>
        <button onClick={() => console.log(gmrMetadata)}>gmrMetadata</button>
        <button onClick={() => console.log(excludedStepIds)}>excludedStepIds</button>
        <button onClick={() => console.log(currentStepId)}>currentStepId</button>
        <button onClick={() => console.log(BackgroundSteps.BrokerFeeRate.id)}>BackgroundSteps.BrokerFeeRate.id</button>
        <button onClick={() => console.log(defaultLoanOfficer)}>defaultLoanOfficer</button>
        <button onClick={() => console.log(user)}>user</button>
        <button onClick={() => console.log(proxyUser)}>proxyUser</button>
        <button onClick={() => console.log(persona)}>persona</button>
        <button onClick={() => console.log(invalidProps)}>invalidProps</button>
        <button onClick={() => console.log(BackgroundSteps.BrokerFeeRate.questions)}>questions</button>
      </React.Fragment>}
    </div>
  );
};

export default BPGetMyRate;
